<template>
  <page-outline :title="$t('Webheader.mandate_dashboard')">
    <template slot="pageContent">
      <b-container fluid>
        <!-- Onglets de navigation principaux -->
        <b-row class="mt-4">
          <b-col cols="12">
            <b-button-group class="shadow" style="width: 100%; display: flex;">
              <b-button
                v-for="tab in mainTabs"
                :key="tab.id"
                :variant="mainTabIndex === tab.id ? 'primary' : 'secondary'"
                @click="mainTabIndex = tab.id"
                class="responsive-button responsive-button-small"
                style="flex: 1;"
                >
                {{ tab.label }}
              </b-button>
            </b-button-group>
          </b-col>
        </b-row>

        <hr class="mx-auto" />

        <!-- Filtres -->
        <b-row class="min-w-100 justify-content-start align-items-center">
          <b-col cols="3">
            <span class="filter-item-title d-block mb-1">{{ $t('Webheader.date_begin') }}</span>
            <datetime-picker-custom
              format="YYYY-MM-DD"
              periodFull
              id="filter-datebegin"
              :class="{'filter-item-input': true, 'filter-item-input-complete': dateBeginFilter}"
              customInputParentClass="filter-item-content"
              customInputClass="w-100"
              style="padding:0.35rem"
              :maxLength="19"
              :placeholderValue="$t('common.datepicker_format_date3')"
              inputIcon="fa-solid fa-calendar"
              :showTime="false"
              v-model="dateBeginFilter"
            />
          </b-col>

          <b-col cols="3">
            <span class="filter-item-title d-block mb-1">{{ $t('Webheader.date_end') }}</span>
            <datetime-picker-custom
              format="YYYY-MM-DD"
              periodFull
              id="filter-dateend"
              :class="{'filter-item-input': true, 'filter-item-input-complete': dateEndFilter}"
              customInputParentClass="filter-item-content"
              customInputClass="w-100"
              style="padding:0.35rem"
              :maxLength="19"
              :placeholderValue="$t('common.datepicker_format_date3')"
              inputIcon="fa-solid fa-calendar"
              :showTime="false"
              v-model="dateEndFilter"
            />
          </b-col>

          <b-col cols="3" v-if="mainTabIndex === 0 || mainTabIndex === 1">
            <span class="filter-item-title d-block mb-1">{{ $t('mandate.status_collection') }}</span>
            <select v-model="statusFilter" class="filter-item-content w-100" style="padding:0.35rem">
              <option value="All">──────────</option>
              <option v-for="s in statusOptions" :key="s.value" :value="s.value">{{ $t(s.label) }}</option>
            </select>
          </b-col>

          <b-col cols="3" v-if="mainTabIndex === 5">
            <span class="filter-item-title d-block mb-1">Type de parcours</span>
            <select v-model="journeyTypeFilter" class="filter-item-content w-100" style="padding:0.35rem">
              <option value="All">──────────</option>
              <option v-for="j in journeyTypeOptions" :key="j" :value="j">{{ j }}</option>
            </select>
          </b-col>

          <!--<b-col cols="3" v-if="mainTabIndex === 6">
            <span class="filter-item-title d-block mb-1">Fraud flag</span>
            <select v-model="fraudFilter" class="filter-item-content w-100" style="padding:0.35rem">
              <option value="All">──────────</option>
              <option value="Fraud">Fraud only</option>
              <option value="NoFraud">Non-fraud only</option>
            </select>
          </b-col>-->

          <b-col cols="3" v-if="mainTabIndex === 6">
            <span class="filter-item-title d-block mb-1">Recurrence</span>
            <select v-model="recurringFilter" class="filter-item-content w-100" style="padding:0.35rem">
              <option value="All">──────────</option>
              <option value="Recurring">Recurring only</option>
              <option value="OneOff">One-off only</option>
            </select>
          </b-col>

          <b-col :cols="(mainTabIndex === 2 || mainTabIndex === 3 || mainTabIndex === 4) ? 6 : 3"
            class="d-flex align-items-end justify-content-end" v-if=" mainTabIndex !== 6">
            <b-button class="btnFilter_2 mr-2" @click="clearFilterFields" :disabled="!hasInputFilter">
              {{ $t('common.rst') }}
            </b-button>
            <b-button class="btnFilter_2" @click="applyFilters">
              {{ $t('common.srch') }}
            </b-button>
          </b-col>
          <b-col cols="3" class="d-flex align-items-end justify-content-end" v-if=" mainTabIndex === 6">
            <b-button class="btnFilter_2 mr-2" @click="clearFilterFields" :disabled="!hasInputFilter">
              {{ $t('common.rst') }}
            </b-button>
            <b-button class="btnFilter_2" @click="applyFilters">
              {{ $t('common.srch') }}
            </b-button>
          </b-col>

        </b-row>

        <hr class="mx-auto mb-4" />

        <!-- Contenu -->
        <b-row>
          <b-col cols="12">
            <b-card class="position-relative">
              <h3 class="text-center mb-4">{{ chartTitle }}</h3>

              <spinner v-if="activateSpinner"></spinner>

              <template v-if="!activateSpinner">

                <!-- Tabs 0 / 1 : Mandate status & Collection status -->
                <div v-if="mainTabIndex === 0 || mainTabIndex === 1">
                  <b-row class="justify-content-center align-items-center">
                    <b-col cols="12" md="7">
                      <pie-chart
                        v-if="hasData"
                        ref="pieChart"
                        :chart-data="currentPieData"
                        :options="chartOptions"
                        style="max-height: 400px;"
                      ></pie-chart>
                      <div v-else class="d-flex justify-content-center">
                        <span class="noResult">{{ $t('common.no_result') }}</span>
                      </div>
                    </b-col>

                    <b-col cols="12" md="5">
                      <ul class="legend-list">
                        <li v-for="(label, idx) in currentLabels" :key="idx" class="legend-item-dashboard">
                          <span class="legend-dot" :style="{ backgroundColor: currentColors[idx] }"></span>
                          <span class="legend-label">{{ label }}</span>
                          <span class="legend-value">{{ currentValues[idx] }}</span>
                        </li>
                      </ul>
                    </b-col>
                  </b-row>

                  <!-- ========================= -->
                  <!-- MANDATE -->
                  <!-- ========================= -->
                  <div v-if="mainTabIndex === 0">
                    <hr class="mx-auto my-4" />

                    <h5 class="mb-3">
                      {{ $t('mandate.dashboard.mandates_by_transaction_type_schema') }}
                    </h5>

                    <b-row>
                      <b-col cols="12" lg="7" class="mb-4">
                        <div class="volume-chart">
                          <bar-chart
                            :chart-data="mandateTypeSchemaChartData"
                            :options="mandateTypeSchemaChartOptions"
                          ></bar-chart>
                        </div>
                      </b-col>

                      <b-col cols="12" lg="5">
                        <div class="table-responsive">
                          <b-table
                            striped
                            hover
                            small
                            :items="mandateTypeSchemaTableItems"
                            :fields="mandateTypeSchemaTableFields"
                            class="mb-0"
                          >
                            <template #cell(percentage)="data">
                              <strong>{{ data.value }} %</strong>
                            </template>
                          </b-table>
                        </div>
                      </b-col>
                    </b-row>
                  </div>


                  <!-- ========================= -->
                  <!-- COLLECTION -->
                  <!-- ========================= -->
                  <div v-if="mainTabIndex === 1">

                    <hr class="mx-auto my-4" />

                    <h5 class="mb-3">
                      {{ $t('mandate.dashboard.collection_performance') }}
                    </h5>

                    <!-- KPI -->
                    <b-row class="mb-4">

                      <b-col cols="12" md="6" lg class="mb-3">
                        <div class="collection-kpi-card">
                          <div class="collection-kpi-label">
                            {{ $t('mandate.dashboard.total_amount') }}
                          </div>

                          <div class="collection-kpi-value">
                            {{ formatCollectionAmount(collectionKpis.totalAmount) }}
                          </div>
                        </div>
                      </b-col>

                      <b-col cols="12" md="6" lg class="mb-3">
                        <div class="collection-kpi-card">
                          <div class="collection-kpi-label">
                            {{ $t('mandate.dashboard.paid_amount') }}
                          </div>

                          <div class="collection-kpi-value">
                            {{ formatCollectionAmount(collectionKpis.paidAmount) }}
                          </div>
                        </div>
                      </b-col>

                      <b-col cols="12" md="6" lg class="mb-3">
                        <div class="collection-kpi-card">
                          <div class="collection-kpi-label">
                            {{ $t('mandate.dashboard.payment_rate') }}
                          </div>

                          <div class="collection-kpi-value">
                            {{ collectionKpis.paymentRate }} %
                          </div>
                        </div>
                      </b-col>

                      <b-col cols="12" md="6" lg class="mb-3">
                        <div class="collection-kpi-card">
                          <div class="collection-kpi-label">
                            {{ $t('mandate.dashboard.rejection_rate') }}
                          </div>

                          <div class="collection-kpi-value">
                            {{ collectionKpis.rejectionRate }} %
                          </div>
                        </div>
                      </b-col>

                      <b-col cols="12" md="6" lg class="mb-3">
                        <div class="collection-kpi-card">
                          <div class="collection-kpi-label">
                            {{ $t('mandate.dashboard.error_rate') }}
                          </div>

                          <div class="collection-kpi-value">
                            {{ collectionKpis.errorRate }} %
                          </div>
                        </div>
                      </b-col>

                    </b-row>


                    <!-- GRAPH + TABLE -->
                    <b-row>

                      <b-col cols="12" lg="7" class="mb-4">

                        <h5 class="mb-3">
                          {{ $t('mandate.dashboard.amount_by_collection_status') }}
                        </h5>

                        <div class="volume-chart">
                          <bar-chart
                            :chart-data="collectionStatusAmountChartData"
                            :options="collectionStatusAmountChartOptions"
                          ></bar-chart>
                        </div>

                      </b-col>

                      <b-col cols="12" lg="5">

                        <h5 class="mb-3">
                          {{ $t('mandate.dashboard.collection_status_summary') }}
                        </h5>

                        <div class="table-responsive">

                          <b-table
                            striped
                            hover
                            small
                            :items="collectionStatusTableItems"
                            :fields="collectionStatusTableFields"
                            class="mb-0"
                          >
                            <template #cell(percentage)="data">
                              <strong>{{ data.value }} %</strong>
                            </template>
                          </b-table>

                        </div>

                      </b-col>

                    </b-row>

                  </div>
                </div>
                <!-- Problematic tab: customer signature error reporting -->
                <div v-else-if="mainTabIndex === 2">

                  <b-alert show variant="light" class="journey-description">
                    {{ $t('mandate.dashboard.signature_error_reporting_description') }}
                  </b-alert>

                  <form-accordion :title="$t('mandate.dashboard.operational_summary')" :isTitleUpperCase="false">

                  <b-row class="mb-4">
                    <b-col cols="12" md="3" class="mb-3 mb-md-0">
                      <div class="kpi-card">
                        <span class="kpi-label">{{ $t('mandate.dashboard.signature_attempts') }}</span>
                        <strong class="kpi-value">{{ signatureErrorKpis.totalAttempts }}</strong>
                      </div>
                    </b-col>
                    <b-col cols="12" md="3" class="mb-3 mb-md-0">
                      <div class="kpi-card">
                        <span class="kpi-label">{{ $t('mandate.dashboard.failed_signatures') }}</span>
                        <strong class="kpi-value">{{ signatureErrorKpis.failedAttempts }}</strong>
                      </div>
                    </b-col>
                    <b-col cols="12" md="3" class="mb-3 mb-md-0">
                      <div class="kpi-card">
                        <span class="kpi-label">{{ $t('mandate.dashboard.Échec_rate') }}</span>
                        <strong class="kpi-value">{{ signatureErrorKpis.ÉchecRate }} %</strong>
                      </div>
                    </b-col>
                    <b-col cols="12" md="3">
                      <div class="kpi-card kpi-card-warning">
                        <span class="kpi-label">{{ $t('mandate.dashboard.main_recurring_issue') }}</span>
                        <strong class="kpi-value kpi-value-small">{{ signatureErrorKpis.mainIssue }}</strong>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" lg="8">
                      <div class="error-chart">
                        <horizontal-bar-chart
                          :chart-data="signatureErrorChartData"
                          :options="signatureErrorChartOptions"
                        ></horizontal-bar-chart>
                      </div>
                    </b-col>

                    <b-col cols="12" lg="4" class="mt-4 mt-lg-0">
                      <div class="error-summary-panel">
                        <h5 class="mb-3">{{ $t('mandate.dashboard.operational_summary') }}</h5>
                        <div class="summary-line">
                          <span>{{ $t('mandate.dashboard.resolved_automatically') }}</span>
                          <strong>{{ signatureErrorKpis.autoResolved }} %</strong>
                        </div>
                        <div class="summary-line">
                          <span>{{ $t('mandate.dashboard.requires_agent_action') }}</span>
                          <strong>{{ signatureErrorKpis.agentAction }}</strong>
                        </div>
                        <div class="summary-line">
                          <span>{{ $t('mandate.dashboard.most_impacted_channel') }}</span>
                          <strong>{{ signatureErrorKpis.mainChannel }}</strong>
                        </div>
                        <div class="summary-line">
                          <span>{{ $t('mandate.dashboard.average_resolution_time') }}</span>
                          <strong>{{ signatureErrorKpis.avgResolutionTime }}</strong>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                  </form-accordion>

                  <form-accordion :title="$t('mandate.dashboard.customer_signature_error_details')" :isTitleUpperCase="false">

                  <b-row class="mt-4">
                    <b-col cols="12">
                      <h5 class="mb-3">{{ $t('mandate.dashboard.customer_signature_error_details') }}</h5>
                      <div class="table-responsive">
                        <b-table
                          striped
                          hover
                          small
                          :items="signatureErrorTableItems"
                          :fields="signatureErrorTableFields"
                          class="mb-0"
                        >
                          <template #cell(severity)="data">
                            <b-badge :variant="severityVariant(data.value)">
                              {{ data.value }}
                            </b-badge>
                          </template>
                          <template #cell(status)="data">
                            <b-badge :variant="errorStatusVariant(data.value)">
                              {{ data.value }}
                            </b-badge>
                          </template>
                        </b-table>
                      </div>
                    </b-col>
                  </b-row>
                  </form-accordion>
                </div>

                <!-- Tab 4 : overview reporting -->
                <div v-else-if="mainTabIndex === 4">
                  <h5 class="overview-section-title">1. {{ $t('mandate.dashboard.issued_mandates_status') }}</h5>
                  <b-row class="mb-4">
                    <b-col cols="12" md="5">
                      <pie-chart
                        v-if="hasData"
                        :chart-data="currentPieData"
                        :options="chartOptions"
                        style="max-height: 260px;"
                      ></pie-chart>
                    </b-col>
                    <b-col cols="12" md="7">
                      <ul class="legend-list">
                        <li v-for="(label, idx) in currentLabels" :key="idx" class="legend-item-dashboard">
                          <span class="legend-dot" :style="{ backgroundColor: currentColors[idx] }"></span>
                          <span class="legend-label">{{ label }}</span>
                          <span class="legend-value">{{ currentValues[idx] }}</span>
                        </li>
                      </ul>
                    </b-col>
                  </b-row>

                  <hr class="mx-auto my-4" />

                  <h5 class="overview-section-title">2. {{ $t('mandate.dashboard.representations_success_rate') }}</h5>
                  <b-row class="mb-4">
                    <b-col cols="12">
                      <div class="table-responsive">
                        <b-table
                          striped hover small
                          :items="representationTableItems"
                          :fields="representationTableFields"
                          class="mb-0"
                        >
                          <template #cell(successRate)="data">
                            <b-badge :variant="representationVariant(data.item.successRateValue)">{{ data.value }}</b-badge>
                          </template>
                        </b-table>
                      </div>
                    </b-col>
                  </b-row>

                  <hr class="mx-auto my-4" />

                  <h5 class="overview-section-title">3. {{ $t('mandate.dashboard.recovery_performance') }}</h5>
                  <b-row class="mb-4">
                    <b-col cols="12" md="4" class="mb-3 mb-md-0">
                      <div class="kpi-card">
                        <span class="kpi-label">{{ $t('mandate.dashboard.recovery_rate') }}</span>
                        <strong class="kpi-value">{{ recoveryKpis.rate }} %</strong>
                      </div>
                    </b-col>
                    <b-col cols="12" md="4" class="mb-3 mb-md-0">
                      <div class="kpi-card">
                        <span class="kpi-label">{{ $t('mandate.dashboard.average_recovery_delay') }}</span>
                        <strong class="kpi-value">{{ recoveryKpis.avgDelayDays }} {{ $t('mandate.dashboard.days') }}</strong>
                      </div>
                    </b-col>
                    <b-col cols="12" md="4">
                      <div class="kpi-card kpi-card-warning">
                        <span class="kpi-label">{{ $t('mandate.dashboard.unpaid_amount_period') }}</span>
                        <strong class="kpi-value kpi-value-small">{{ recoveryKpis.unpaidAmountLabel }}</strong>
                      </div>
                    </b-col>
                  </b-row>

                  <hr class="mx-auto my-4" />

                  <h5 class="overview-section-title">4. {{ $t('mandate.dashboard.usage_statistics_audit_trail') }}</h5>
                  <b-row class="mb-4">
                    <b-col cols="12">
                      <div class="table-responsive">
                        <b-table
                          striped hover small
                          :items="auditTableItems"
                          :fields="auditTableFields"
                          class="mb-0"
                        ></b-table>
                      </div>
                    </b-col>
                  </b-row>

                  <hr class="mx-auto my-4" />

                  <h5 class="overview-section-title">5. {{ $t('mandate.dashboard.fraud_alerts_events') }}</h5>
                  <b-row class="mb-3">
                    <b-col cols="12" md="4" class="mb-2">
                      <div class="kpi-card kpi-card-compact">
                        <span class="kpi-label">{{ $t('mandate.dashboard.fraud_rate') }}</span>
                        <strong class="kpi-value">{{ fraudKpis.fraudRate }} %</strong>
                      </div>
                    </b-col>
                    <b-col cols="12" md="4" class="mb-2">
                      <div class="kpi-card kpi-card-compact">
                        <span class="kpi-label">{{ $t('mandate.dashboard.total_amount_at_risk') }}</span>
                        <strong class="kpi-value kpi-value-small">{{ fraudKpis.totalAmountLabel }}</strong>
                      </div>
                    </b-col>
                    <b-col cols="12" md="4" class="mb-2">
                      <div class="kpi-card kpi-card-compact">
                        <span class="kpi-label">{{ $t('mandate.dashboard.detected_by_sncf_bank') }}</span>
                        <strong class="kpi-value kpi-value-small">{{ fraudKpis.sncfCount }} / {{ fraudKpis.bankCount }}</strong>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12">
                      <div class="table-responsive">
                        <b-table
                          striped hover small
                          :items="fraudTableItems"
                          :fields="fraudTableFields"
                          class="mb-0 clickable-rows"
                          @row-clicked="goToFraudCase"
                        >
                          <template #cell(severity)="data">
                            <b-badge :variant="fraudSeverityVariant(data.value)">{{ data.value }}</b-badge>
                          </template>
                        </b-table>
                      </div>
                    </b-col>
                  </b-row>
                </div>

                <!-- Tab 5 : Journal du parcours technique - DSI / support applicatif -->
                <div v-else-if="mainTabIndex === 5">
                  <b-row class="mb-4">
                    <b-col cols="12" md="3" class="mb-3 mb-md-0">
                      <div class="kpi-card">
                        <span class="kpi-label">{{ $t('mandate.dashboard.total_events') }}</span>
                        <strong class="kpi-value">{{ techLogKpis.total }}</strong>
                      </div>
                    </b-col>
                    <b-col cols="12" md="3" class="mb-3 mb-md-0">
                      <div class="kpi-card">
                        <span class="kpi-label">{{ $t('mandate.dashboard.success_rate') }}</span>
                        <strong class="kpi-value">{{ techLogKpis.successRate }} %</strong>
                      </div>
                    </b-col>
                    <b-col cols="12" md="3" class="mb-3 mb-md-0">
                      <div class="kpi-card">
                        <span class="kpi-label">Échecs sur la période</span>
                        <strong class="kpi-value">{{ techLogKpis.ÉchecCount }}</strong>
                      </div>
                    </b-col>
                    <b-col cols="12" md="3">
                      <div class="kpi-card kpi-card-warning">
                        <span class="kpi-label">{{ $t('mandate.dashboard.top_technical_cause') }}</span>
                        <strong class="kpi-value kpi-value-small">{{ techLogKpis.topCause }}</strong>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12">
                      <h5 class="mb-3">Étapes du parcours - volume de succès et d’échecs</h5>
                      <div class="volume-chart">
                        <bar-chart :chart-data="techJourneyChartData" :options="techJourneyChartOptions"></bar-chart>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row class="mt-4">
                    <b-col cols="12">
                      <h5 class="mb-3">{{ $t('mandate.dashboard.technical_event_log') }}</h5>
                      <div class="table-responsive tech-log-table">
                        <b-table
                          striped hover small
                          :items="techLogTableItems"
                          :fields="techLogTableFields"
                          class="mb-0"
                        >
                          <template #cell(status)="data">
                            <b-badge :variant="data.value === 'Success' ? 'success' : 'danger'">{{ data.value }}</b-badge>
                          </template>
                          <template #cell(errorCode)="data">
                            <code v-if="data.value">{{ data.value }}</code>
                            <span v-else>-</span>
                          </template>
                        </b-table>
                      </div>
                    </b-col>
                  </b-row>
                </div>

                <!-- Tab 6 : Statistiques des impayés et rejets -->
                <div v-else-if="mainTabIndex === 6">
                  <h5 class="overview-section-title">{{ $t('mandate.dashboard.rejects_rtransactions_by_motif') }}</h5>
                  <b-row class="mb-4">
                    <b-col cols="12" md="6" class="mb-2">
                      <div class="kpi-card kpi-card-compact">
                        <span class="kpi-label">{{ $t('mandate.dashboard.total_rejects_period') }}</span>
                        <strong class="kpi-value">{{ rejectKpis.total.toLocaleString('en-US') }}</strong>
                      </div>
                    </b-col>
                    <b-col cols="12" md="6" class="mb-2">
                      <div class="kpi-card kpi-card-compact">
                        <span class="kpi-label">{{ $t('mandate.dashboard.top_return_code') }}</span>
                        <strong class="kpi-value kpi-value-small">{{ rejectKpis.topMotif }}</strong>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="mb-5">
                    <b-col cols="12">
                      <div class="volume-chart">
                        <bar-chart ref="motifChart" :chart-data="motifChartData" :options="motifChartOptions"></bar-chart>
                      </div>
                    </b-col>
                  </b-row>

                  <hr class="mx-auto my-4" />

                  <b-row class="mb-4">
                    <b-col cols="12" md="3" class="mb-3 mb-md-0">
                      <div class="kpi-card">
                        <span class="kpi-label">{{ $t('mandate.dashboard.total_rejects_unpaid') }}</span>
                        <strong class="kpi-value">{{ unpaidRejectKpis.totalCount }}</strong>
                      </div>
                    </b-col>
                    <b-col cols="12" md="3" class="mb-3 mb-md-0">
                      <div class="kpi-card">
                        <span class="kpi-label">{{ $t('mandate.dashboard.total_amount') }}</span>
                        <strong class="kpi-value kpi-value-small">{{ unpaidRejectKpis.totalAmountLabel }}</strong>
                      </div>
                    </b-col>
                    <b-col cols="12" md="3" class="mb-3 mb-md-0">
                      <div class="kpi-card kpi-card-warning">
                        <span class="kpi-label">{{ $t('mandate.dashboard.reject_rate') }}</span>
                        <strong class="kpi-value">{{ unpaidRejectKpis.rejectRate }} %</strong>
                      </div>
                    </b-col>
<!--                    <b-col cols="12" md="3">
                      <div class="kpi-card kpi-card-warning">
                        <span class="kpi-label">{{ $t('mandate.dashboard.fraud_rate') }}</span>
                        <strong class="kpi-value">{{ unpaidRejectKpis.fraudRate }} %</strong>
                      </div>
                    </b-col> -->
                  </b-row>

                  <b-row>
                    <b-col cols="12">
                      <h5 class="mb-3">{{ $t('mandate.dashboard.by_follow_up_status') }}</h5>
                      <pie-chart
                        ref="followUpChart"
                        :chart-data="followUpChartData"
                        :options="chartOptions"
                        style="max-height: 360px;"
                      ></pie-chart>
                    </b-col>
                  </b-row>

                  <b-row class="mt-4">
                    <b-col cols="12">
                      <h5 class="mb-3">{{ $t('mandate.dashboard.unpaid_reject_detail') }}</h5>
                      <div class="table-responsive">
                        <b-table
                          striped hover small
                          :items="unpaidRejectTableItems"
                          :fields="unpaidRejectTableFields"
                          class="mb-0"
                        >
                          <!--<template #cell(fraudLabel)="data">
                            <b-badge :variant="data.value === 'Oui' ? 'danger' : 'secondary'">{{ data.value }}</b-badge>
                          </template>-->
                          <template #cell(recurringLabel)="data">
                            <b-badge :variant="data.value === 'Oui' ? 'warning' : 'secondary'">{{ data.value }}</b-badge>
                          </template>
                        </b-table>
                      </div>
                    </b-col>
                  </b-row>
                </div>

                <!-- Tab 3 : processing_time tab: user journey monitoring -->
                <div v-else>
                  <b-alert show variant="light" class="journey-description">
                    {{ $t('mandate.dashboard.journey_monitoring_description') }}
                  </b-alert>

                  <b-row class="mb-4">
                    <b-col cols="12" md="3" class="mb-3 mb-md-0">
                      <div class="kpi-card">
                        <span class="kpi-label">{{ $t('mandate.dashboard.unique_users') }}</span>
                        <strong class="kpi-value">{{ journeyKpis.uniqueUsers }}</strong>
                      </div>
                    </b-col>
                    <b-col cols="12" md="3" class="mb-3 mb-md-0">
                      <div class="kpi-card">
                        <span class="kpi-label">{{ $t('mandate.dashboard.average_processing_time_page') }}</span>
                        <strong class="kpi-value">{{ formatDuration(journeyKpis.avgTimeMs) }}</strong>
                      </div>
                    </b-col>
                    <b-col cols="12" md="3" class="mb-3 mb-md-0">
                      <div class="kpi-card">
                        <span class="kpi-label">{{ $t('mandate.dashboard.average_abandonment_rate') }}</span>
                        <strong class="kpi-value">{{ journeyKpis.avgAbandonmentRate }} %</strong>
                      </div>
                    </b-col>
                    <b-col cols="12" md="3">
                      <div class="kpi-card kpi-card-warning">
                        <span class="kpi-label">{{ $t('mandate.dashboard.overall_application_status') }}</span>
                        <strong class="kpi-value kpi-value-small">{{ journeyKpis.mainFriction }}</strong>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12">
                      <div class="journey-chart">
                        <horizontal-bar-chart
                          :chart-data="journeyChartData"
                          :options="journeyChartOptions"
                        ></horizontal-bar-chart>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row class="mt-4">
                    <b-col cols="12">
                      <h5 class="mb-3">{{ $t('mandate.dashboard.aggregated_anonymized_data') }}</h5>
                      <div class="table-responsive">
                        <b-table
                          striped
                          hover
                          small
                          :items="journeyTableItems"
                          :fields="journeyTableFields"
                          class="mb-0"
                        >
                          <template #cell(abandonmentRate)="data">
                            <b-badge :variant="abandonmentVariant(data.item.abandonmentRateValue)">
                              {{ data.value }}
                            </b-badge>
                          </template>
                          <template #cell(status)="data">
                            <b-badge :variant="statusVariant(data.value)">
                              {{ data.value }}
                            </b-badge>
                          </template>
                        </b-table>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </template>

              <b-row class="mt-4">
                <b-col cols="12" class="d-flex justify-content-end">
                <div
                  v-if="mainTabIndex === 0 || mainTabIndex === 1 || mainTabIndex === 6"
                  class="export-wrapper"
                >
                  <b-button
                    class="btnFilter_2"
                    @click.stop="showExportModal = !showExportModal"
                  >
                    <i class="fa-light fa-upload"></i>
                    {{ $t('mandate.export') }}

                    <i
                      class="fa-light ml-2"
                      :class="showExportModal ? 'fa-chevron-up' : 'fa-chevron-down'"
                    ></i>
                  </b-button>

                  <div
                    v-if="showExportModal"
                    class="export-menu"
                  >
                    <button
                      type="button"
                      class="export-menu-item"
                      @click.stop="chooseDashboardExport('csv')"
                    >
                      <i class="fa-light fa-file-csv mr-2"></i>
                      CSV
                    </button>

                    <button
                      type="button"
                      class="export-menu-item"
                      @click.stop="chooseDashboardExport('pdf')"
                    >
                      <i class="fa-light fa-file-pdf mr-2"></i>
                      PDF
                    </button>
                  </div>
                  </div>

                  <b-button
                  v-else
                  class="btnFilter_2"
                  @click="exportData"
                  >
                  <i class="fa-light fa-upload"></i>
                  {{ $t('mandate.export') }}
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import BackButton from '@/components/common/backButton.vue'
import Spinner from '@/components/common/spinner.vue'
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import { Pie, Bar, HorizontalBar } from 'vue-chartjs'
import { errorMessageAlert } from '@/helpers/alert'
import moment from 'moment-timezone'
import formAccordion from '@/components/common/FormAccordion.vue'
import { jsPDF } from 'jspdf'
import autoTable from 'jspdf-autotable'

export default {
  name: 'MandateDashboard',
  components: {
    'page-outline': PageOutline,
    'back-button': BackButton,
    spinner: Spinner,
    'form-accordion': formAccordion,
    'datetime-picker-custom': dateTimePicker,
    'pie-chart': {
      extends: Pie,
      props: ['chartData', 'options'],
      mounted () {
        this.renderChart(this.chartData, this.options)
      },
      watch: {
        chartData (newData) {
          if (this._chart) this._chart.destroy()
          this.renderChart(newData, this.options)
        }
      }
    },
    'bar-chart': {
      extends: Bar,
      props: ['chartData', 'options'],
      mounted () {
        this.renderChart(this.chartData, this.options)
        this.$nextTick(() => {
          if (this._chart) this._chart.resize()
        })
      },
      watch: {
        chartData (newData) {
          if (this._chart) this._chart.destroy()
          this.renderChart(newData, this.options)
        }
      }
    },
    'horizontal-bar-chart': {
      extends: HorizontalBar,
      props: ['chartData', 'options'],
      mounted () {
        this.renderChart(this.chartData, this.options)
      },
      watch: {
        chartData (newData) {
          if (this._chart) this._chart.destroy()
          this.renderChart(newData, this.options)
        }
      }
    }
  },
  data () {
    return {
      activateSpinner: false,
      mainTabIndex: 0,
      dateBeginFilter: null,
      dateEndFilter: null,
      statusFilter: 'All',
      entityFilter: 'All',
      motifFilter: 'All',
      journeyTypeFilter: 'All',
      techStatusFilter: 'All',
      //fraudFilter: 'All',
      recurringFilter: 'All',
      journeyTypeOptions: [
        'Création du mandat',
        'Création du prélèvement',
        'Échéancier de paiement',
        'Transaction processing'
      ],
      activateSpinner: false,
      showExportModal: false,
      mainTabIndex: 0,
      entityOptions: [
        'SNCF Voyageurs',
        'SNCF Reseau',
        'SNCF Gares & Connexions',
        'SNCF Immobilier',
        'Rail Logistics Europe'
      ],
      motifOptions: [
        { code: 'AC04', label: 'Compte clôturé' },
        { code: 'AC06', label: 'Compte bloqué' },
        { code: 'AM04', label: 'Fonds insuffisants' },
        { code: 'MD01', label: 'Mandat inexistant' },
        { code: 'MD07', label: 'Débiteur décédé' },
        { code: 'MS02', label: 'Refusé par le débiteur' },
        { code: 'MS03', label: 'Motif non précisé' }
      ],
      mandateStats: [],
      mandateStats: [],
      crtInfo: {},
      collectionStats: [],
      collectionStats: [],
      // mock stats impayes/rejets - couvre date, taux, nature, nombre, montant, motif, fraude, suivi, R-transactions, recurrence
      unpaidRejectStats: [],
      techJourneyLog: [
        { step: 'Connexion', journeyType: 'Création du mandat', successCount: 1262, ÉchecCount: 18, errorCode: null, technicalCause: null, functionalCause: null, status: 'Success', timestamp: '2026-07-13 09:12' },
        { step: 'Connexion', journeyType: 'Création du mandat', successCount: 0, ÉchecCount: 18, errorCode: 'AUTH_TIMEOUT_408', technicalCause: 'Expiration de la session sur le fournisseur d’identité', functionalCause: 'Délai d’authentification dépassé', status: 'Échec', timestamp: '2026-07-13 09:14' },
        { step: 'Création du mandat', journeyType: 'Création du mandat', successCount: 1228, ÉchecCount: 2, errorCode: null, technicalCause: null, functionalCause: null, status: 'Success', timestamp: '2026-07-13 10:02' },
        { step: 'Création du mandat', journeyType: 'Création du mandat', successCount: 0, ÉchecCount: 2, errorCode: 'DB_CONN_500', technicalCause: 'Pool de connexions à la base de données épuisé', functionalCause: 'Mandat non enregistré', status: 'Échec', timestamp: '2026-07-13 10:05' },
        { step: 'Validation OTP', journeyType: 'Création du mandat', successCount: 1160, ÉchecCount: 18, errorCode: null, technicalCause: null, functionalCause: null, status: 'Success', timestamp: '2026-07-13 11:20' },
        { step: 'Validation OTP', journeyType: 'Création du mandat', successCount: 0, ÉchecCount: 18, errorCode: 'OTP_EXPIRED_410', technicalCause: 'Jeton OTP expiré côté serveur avant l’appel de validation', functionalCause: 'Délai d’authentification dépassé', status: 'Échec', timestamp: '2026-07-13 11:24' },
        { step: 'Création du prélèvement', journeyType: 'Création du prélèvement', successCount: 1068, ÉchecCount: 3, errorCode: null, technicalCause: null, functionalCause: null, status: 'Success', timestamp: '2026-07-13 12:40' },
        { step: 'Création du prélèvement', journeyType: 'Création du prélèvement', successCount: 0, ÉchecCount: 3, errorCode: 'NPE_COLLECTION_500', technicalCause: 'Exception de pointeur nul lors du mapping du montant du prélèvement', functionalCause: 'Format de montant invalide', status: 'Échec', timestamp: '2026-07-13 12:42' },
        { step: 'Échéancier de paiement', journeyType: 'Échéancier de paiement', successCount: 1054, ÉchecCount: 1, errorCode: null, technicalCause: null, functionalCause: null, status: 'Success', timestamp: '2026-07-13 13:15' },
        { step: 'Échéancier de paiement', journeyType: 'Échéancier de paiement', successCount: 0, ÉchecCount: 1, errorCode: 'SCHED_CONFLICT_409', technicalCause: 'Conflit de planification dans le moteur de règles récurrentes', functionalCause: 'Entrée d’échéancier en double', status: 'Échec', timestamp: '2026-07-13 13:16' }
      ],
      techJourneyChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { position: 'bottom' },
        scales: {
          xAxes: [{ ticks: { beginAtZero: true } }],
          yAxes: [{ ticks: { autoSkip: false } }]
        }
      },
      entityVolumeStats: [
        { entity: 'SNCF Voyageurs', count: 542, amount: 128450 },
        { entity: 'SNCF Reseau', count: 118, amount: 42300 },
        { entity: 'SNCF Gares & Connexions', count: 96, amount: 18750 },
        { entity: 'SNCF Immobilier', count: 41, amount: 9600 },
        { entity: 'Rail Logistics Europe', count: 63, amount: 21980 }
      ],
      // Sample customer signature error data. Replace with the partner reporting API response.
      signatureErrorStats: [
        { errorType: 'Délai d’authentification dépassé', count: 18, severity: 'Moyenne', channel: 'Web', userProfile: 'Client', ÉchecStage: 'Vérification de l’identité', status: 'Sous surveillance', avgResolutionMin: 7, lastOccurrence: '2026-07-12 16:42' },
        { errorType: 'Données client invalides', count: 14, severity: 'Moyenne', channel: 'Centre d’appels', userProfile: 'Advisor', ÉchecStage: 'Validation des données client', status: 'Action requise', avgResolutionMin: 11, lastOccurrence: '2026-07-12 15:18' },
        { errorType: 'Refus du client', count: 11, severity: 'Faible', channel: 'Centre d’appels', userProfile: 'Client', ÉchecStage: 'Confirmation de la signature', status: 'Vérification métier', avgResolutionMin: 4, lastOccurrence: '2026-07-12 14:55' },
        { errorType: 'Lien de signature expiré', count: 9, severity: 'Faible', channel: 'Email', userProfile: 'Client', ÉchecStage: 'Ouverture du lien', status: 'Résolu automatiquement', avgResolutionMin: 2, lastOccurrence: '2026-07-12 13:20' },
        { errorType: 'Erreur technique du service de signature', count: 6, severity: 'Élevée', channel: 'Web', userProfile: 'Client', ÉchecStage: 'Soumission de la signature', status: 'Résolu', avgResolutionMin: 18, lastOccurrence: '2026-07-12 12:47' },
        { errorType: 'OTP non reçu', count: 5, severity: 'Moyenne', channel: 'Mobile', userProfile: 'Client', ÉchecStage: 'Authentification', status: 'Sous surveillance', avgResolutionMin: 9, lastOccurrence: '2026-07-12 11:36' },
        { errorType: 'Parcours client interrompu', count: 4, severity: 'Faible', channel: 'Web', userProfile: 'Client', ÉchecStage: 'Vérification des documents', status: 'Résolu automatiquement', avgResolutionMin: 3, lastOccurrence: '2026-07-12 10:12' }
      ],
      // mock rejets/R-transactions, a remplacer par pacs.002/pacs.004
      rejectStats: [],
      representationStats: [
        { reason: 'Fonds insuffisants (AM04)', attempts: 128, successes: 79 },
        { reason: 'Compte bloqué (AC06)', attempts: 34, successes: 12 },
        { reason: 'Refusé par le débiteur (MS02)', attempts: 22, successes: 6 },
        { reason: 'Motif non précisé (MS03)', attempts: 18, successes: 9 }
      ],
      recoveryStats: {
        totalUnpaid: 84,
        totalUnpaidAmount: 15420,
        recovered: 61,
        avgDelayDays: 9.4
      },

      auditStats: [
        { action: 'Création du mandat', count: 542, user: 'Plusieurs (portail)', lastEvent: '2026-07-12' },
        { action: 'Modification du mandat', count: 87, user: 'Plusieurs (portail)', lastEvent: '2026-07-12' },
        { action: 'Validation du mandat', count: 498, user: 'Plusieurs (callback PSP)', lastEvent: '2026-07-13' },
        { action: 'Annulation du mandat', count: 23, user: 'Plusieurs (portail)', lastEvent: '2026-07-11' },
        { action: 'Création du prélèvement', count: 1310, user: 'Plusieurs (portail)', lastEvent: '2026-07-13' }
      ],
      fraudStats: [
        { caseId: 1, date: '2026-07-10', type: 'Plusieurs mandats pour un même débiteur', entity: 'SNCF Voyageurs', severity: 'Élevée', detectedBy: 'SNCF', amount: 1240 },
        { caseId: 2, date: '2026-07-11', type: 'Montant inhabituel détecté', entity: 'SNCF Reseau', severity: 'Moyenne', detectedBy: 'Bank', amount: 680 },
        { caseId: 3, date: '2026-07-12', type: 'Tentative avec un IBAN non concordant', entity: 'SNCF Voyageurs', severity: 'Élevée', detectedBy: 'Bank', amount: 2150 },
        { caseId: 4, date: '2026-07-12', type: 'Création/annulation rapide de mandats', entity: 'Rail Logistics Europe', severity: 'Faible', detectedBy: 'SNCF', amount: 310 },
        { caseId: 5, date: '2026-07-13', type: 'Suspicion d’usurpation d’identité', entity: 'SNCF Voyageurs', severity: 'Élevée', detectedBy: 'Bank', amount: 1890 }
      ],
      userJourneyStats: [
        { page: 'Connexion', views: 1280, uniqueUsers: 1045, avgTimeMs: 320, abandonmentRate: 0.8, successRate: 99.8, errors: 1, nextStep: 'Dashboard', status: 'Opérationnel' },
        { page: 'Dashboard', views: 1264, uniqueUsers: 1038, avgTimeMs: 410, abandonmentRate: 0.6, successRate: 99.9, errors: 0, nextStep: 'Création du mandat', status: 'Opérationnel' },
        { page: 'Création du mandat', views: 1230, uniqueUsers: 1019, avgTimeMs: 540, abandonmentRate: 1.2, successRate: 99.6, errors: 2, nextStep: 'Sélection de la banque', status: 'Opérationnel' },
        { page: 'Sélection de la banque', views: 1205, uniqueUsers: 1001, avgTimeMs: 475, abandonmentRate: 1.0, successRate: 99.7, errors: 1, nextStep: 'Validation OTP', status: 'Opérationnel' },
        { page: 'Validation OTP', views: 1178, uniqueUsers: 976, avgTimeMs: 1450, abandonmentRate: 6.4, successRate: 93.2, errors: 18, nextStep: 'Signature du mandat', status: 'Point de friction' },
        { page: 'Signature du mandat', views: 1103, uniqueUsers: 913, avgTimeMs: 590, abandonmentRate: 1.6, successRate: 99.3, errors: 3, nextStep: 'Détails du mandat', status: 'Bon' },
        { page: 'Détails du mandat', views: 1085, uniqueUsers: 898, avgTimeMs: 380, abandonmentRate: 0.7, successRate: 99.8, errors: 1, nextStep: 'Création du prélèvement', status: 'Opérationnel' },
        { page: 'Création du prélèvement', views: 1071, uniqueUsers: 887, avgTimeMs: 690, abandonmentRate: 1.4, successRate: 99.4, errors: 3, nextStep: 'Liste des échéanciers de paiement', status: 'Bon' },
        { page: 'Liste des échéanciers de paiement', views: 1055, uniqueUsers: 875, avgTimeMs: 485, abandonmentRate: 0.7, successRate: 99.8, errors: 1, nextStep: 'Liste des transactions', status: 'Opérationnel' },
        { page: 'Liste des transactions', views: 1044, uniqueUsers: 868, avgTimeMs: 315, abandonmentRate: 0.3, successRate: 100.0, errors: 0, nextStep: 'Parcours terminé', status: 'Opérationnel' }
      ],
      chartOptions: {
        responsive: true,
        aspectRatio: 1,
        maintainAspectRatio: false,
        legend: { display: false }
      },
      entityVolumeChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              const label = data.datasets[tooltipItem.datasetIndex].label || ''
              return label + ': ' + tooltipItem.yLabel
            }
          }
        },
        scales: {
          xAxes: [{ ticks: { autoSkip: false } }],
          yAxes: [{ ticks: { beginAtZero: true } }]
        }
      },
      motifChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        scales: {
          xAxes: [{ ticks: { autoSkip: false } }],
          yAxes: [{ ticks: { beginAtZero: true } }]
        }
      },
      signatureErrorChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        tooltips: {
          callbacks: {
            label: function (tooltipItem) {
              return 'Tentatives échouées: ' + tooltipItem.xLabel
            }
          }
        },
        scales: {
          xAxes: [{
            ticks: { beginAtZero: true, precision: 0 },
            scaleLabel: { display: true, labelString: 'Nombre de tentatives de signature échouées' }
          }],
          yAxes: [{
            ticks: { autoSkip: false }
          }]
        }
      },
      journeyChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { position: 'bottom' },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function (tooltipItem, data) {
              const label = data.datasets[tooltipItem.datasetIndex].label || ''
              const suffix = tooltipItem.datasetIndex === 0 ? ' ms' : ' %'
              return label + ': ' + tooltipItem.xLabel + suffix
            }
          }
        },
        scales: {
          xAxes: [{
            ticks: { beginAtZero: true },
            scaleLabel: { display: true, labelString: 'Valeur' }
          }],
          yAxes: [{
            ticks: { autoSkip: false }
          }]
        }
      }
    }
  },
  created () {
    this.fetchStats()
  },
  computed: {
    mainTabs () {
      return [
        {
          id: 0,
          label: this.$t('mandate.dashboard_status_mandates')
        },
        {
          id: 1,
          label: this.$t('mandate.dashboard_status_collections')
        },

        // Tabs 2 à 5 désactivés temporairement
        // {
        //   id: 2,
        //   label: this.$t('mandate.dashboard_problematic')
        // },
        // {
        //   id: 3,
        //   label: this.$t('mandate.dashboard_processing_time')
        // },
        // {
        //   id: 4,
        //   label: 'Vue d’ensemble du reporting'
        // },
        // {
        //   id: 5,
        //   label: 'Journal du parcours technique'
        // },

        {
          id: 6,
          label: this.$t('mandate.dashboard.rtransactions')
        }
      ]
    },
    mandateTypeSchemaStats () {
      const stats = {
        oneOff: {
          CORE: 0,
          B2B: 0
        },
        recurring: {
          CORE: 0,
          B2B: 0
        }
      }

      this.mandateStats.forEach(mandate => {
        const type = Number(mandate.type_transaction)
        const schema = String(mandate.schema_code || '').toUpperCase()

        // 1 = One-off
        // 2 = Recurring
        const transactionType = type === 1
          ? 'oneOff'
          : type === 2
            ? 'recurring'
            : null

        if (
          transactionType &&
          Object.prototype.hasOwnProperty.call(stats[transactionType], schema)
        ) {
          stats[transactionType][schema]++
        }
      })

      return stats
    },

    mandateTypeSchemaChartData () {
      return {
        labels: [
          this.$t('mandate.transaction_type_one_off'),
          this.$t('mandate.transaction_type_recurring')
        ],
        datasets: [
          {
            label: 'CORE',
            data: [
              this.mandateTypeSchemaStats.oneOff.CORE,
              this.mandateTypeSchemaStats.recurring.CORE
            ],
            backgroundColor: '#2563EB'
          },
          {
            label: 'B2B',
            data: [
              this.mandateTypeSchemaStats.oneOff.B2B,
              this.mandateTypeSchemaStats.recurring.B2B
            ],
            backgroundColor: '#8B5CF6'
          }
        ]
      }
    },

    mandateTypeSchemaTableFields () {
      return [
        {
          key: 'transactionType',
          label: this.$t('mandate.transaction_type'),
          sortable: true
        },
        {
          key: 'schema',
          label: this.$t('mandate.schema'),
          sortable: true
        },
        {
          key: 'count',
          label: this.$t('mandate.count'),
          sortable: true
        },
        {
          key: 'percentage',
          label: '%',
          sortable: true
        }
      ]
    },

    mandateTypeSchemaTableItems () {
      const stats = this.mandateTypeSchemaStats
      const total = this.mandateStats.length

      const percentage = count => {
        if (!total) return '0.0'
        return ((count / total) * 100).toFixed(1)
      }

      return [
        {
          transactionType: this.$t('mandate.transaction_type_one_off'),
          schema: 'CORE',
          count: stats.oneOff.CORE,
          percentage: percentage(stats.oneOff.CORE)
        },
        {
          transactionType: this.$t('mandate.transaction_type_one_off'),
          schema: 'B2B',
          count: stats.oneOff.B2B,
          percentage: percentage(stats.oneOff.B2B)
        },
        {
          transactionType: this.$t('mandate.transaction_type_recurring'),
          schema: 'CORE',
          count: stats.recurring.CORE,
          percentage: percentage(stats.recurring.CORE)
        },
        {
          transactionType: this.$t('mandate.transaction_type_recurring'),
          schema: 'B2B',
          count: stats.recurring.B2B,
          percentage: percentage(stats.recurring.B2B)
        }
      ]
    },
    mandateTypeSchemaChartOptions () {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'bottom'
        },
        scales: {
          xAxes: [{
            stacked: false,
            ticks: {
              autoSkip: false
            }
          }],
          yAxes: [{
            stacked: false,
            ticks: {
              beginAtZero: true,
              precision: 0
            },
            scaleLabel: {
              display: true,
              labelString: this.$t('mandate.number_of_mandates')
            }
          }]
        }
      }
    },
    collectionKpis () {
      const collections = this.collectionStats || []

      const totalCount = collections.length

      const totalAmount = collections.reduce(
        (sum, item) =>
          sum + Number(item.Amount || 0),
        0
      )

      // 7 = Payé
      const paidCollections = collections.filter(
        item => String(item.Status) === '7'
      )

      // 6 = Rejeté
      const rejectedCollections = collections.filter(
        item => String(item.Status) === '6'
      )

      // 3 = Erreur métier
      // 4 = Erreur technique
      const errorCollections = collections.filter(
        item =>
          ['3', '4'].includes(String(item.Status))
      )

      const paidAmount = paidCollections.reduce(
        (sum, item) =>
          sum + Number(item.Amount || 0),
        0
      )

      const calculateRate = count => {
        if (!totalCount) return '0.0'

        return (
          (count / totalCount) *
          100
        ).toFixed(1)
      }

      return {
        totalCount,
        totalAmount,
        paidAmount,

        paymentRate:
          calculateRate(paidCollections.length),

        rejectionRate:
          calculateRate(rejectedCollections.length),

        errorRate:
          calculateRate(errorCollections.length)
      }
    },

    collectionStatusAmountStats () {
      const stats = {}

      this.collectionStats.forEach(collection => {
        const status =
          String(collection.Status ?? '')

        const amount =
          Number(collection.Amount || 0)

        if (!stats[status]) {
          stats[status] = {
            status,
            count: 0,
            amount: 0
          }
        }

        stats[status].count++
        stats[status].amount += amount
      })

      return Object.values(stats)
        .sort(
          (a, b) =>
            Number(a.status) -
            Number(b.status)
        )
    },

    collectionStatusAmountChartData () {
      return {
        labels:
          this.collectionStatusAmountStats.map(
            item =>
              this.$t(
                `mandate.status_collection_${item.status}`
              )
          ),

        datasets: [
          {
            label:
              this.$t('mandate.dashboard.amount'),

            data:
              this.collectionStatusAmountStats.map(
                item =>
                  Number(item.amount.toFixed(2))
              ),

            backgroundColor:
              this.collectionStatusAmountStats.map(
                item =>
                  this.statusColorMap[item.status] ||
                  '#9CA3AF'
              )
          }
        ]
      }
    },

    collectionStatusAmountChartOptions () {
      return {
        responsive: true,
        maintainAspectRatio: false,

        legend: {
          display: false
        },

        tooltips: {
          callbacks: {
            label: tooltipItem => {
              return (
                Number(tooltipItem.yLabel)
                  .toLocaleString(
                    'fr-FR',
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    }
                  ) +
                ' €'
              )
            }
          }
        },

        scales: {
          xAxes: [{
            ticks: {
              autoSkip: false
            }
          }],

          yAxes: [{
            ticks: {
              beginAtZero: true,

              callback: value =>
                value + ' €'
            },

            scaleLabel: {
              display: true,
              labelString:
                this.$t('mandate.dashboard.amount')
            }
          }]
        }
      }
    },

    collectionStatusTableFields () {
      return [
        {
          key: 'statusLabel',
          label:
            this.$t('mandate.dashboard.status'),
          sortable: true
        },
        {
          key: 'count',
          label:
            this.$t('mandate.dashboard.number'),
          sortable: true
        },
        {
          key: 'amountLabel',
          label:
            this.$t('mandate.dashboard.amount'),
          sortable: true
        },
        {
          key: 'percentage',
          label: '%',
          sortable: true
        }
      ]
    },

    collectionStatusTableItems () {
      const total =
        this.collectionStats.length

      return this.collectionStatusAmountStats.map(
        item => ({
          statusLabel:
            this.$t(
              `mandate.status_collection_${item.status}`
            ),

          count: item.count,

          amountLabel:
            item.amount.toLocaleString(
              'fr-FR',
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }
            ) + ' €',

          percentage:
            total
              ? (
                  (item.count / total) *
                  100
                ).toFixed(1)
              : '0.0'
        })
      )
    },
    hasInputFilter () {
      return !!this.dateBeginFilter ||
        !!this.dateEndFilter ||
        this.statusFilter !== 'All' ||
        this.entityFilter !== 'All' ||
        this.motifFilter !== 'All' ||
        this.journeyTypeFilter !== 'All' ||
        this.techStatusFilter !== 'All' ||
        this.recurringFilter !== 'All'
    },
    chartTitle () {
      const titles = [
        this.$t('mandate.dashboard_breakdown_mandates'),
        this.$t('mandate.dashboard_breakdown_collections'),
        this.$t('mandate.dashboard_breakdown_problematic'),
        this.$t('mandate.dashboard_breakdown_delay'),
        'Vue d’ensemble du reporting',
        'Journal technique du parcours (DSI / Support)',
        this.$t('mandate.dashboard.unpaid_reject_statistics')
      ]
      return titles[this.mainTabIndex] || ''
    },
    activeStats () {
      // tabIndex 0 -> mandates, 1/4 -> collections (tab 4 reuses mandates data for the overview pie)
      if (this.mainTabIndex === 0 || this.mainTabIndex === 4) return this.mandateStats
      return this.collectionStats
    },
    overviewMandateBuckets () {
      const counts = {}
      this.mandateStats.forEach(item => {
        const code = String(item.status ?? item.Status ?? '')
        counts[code] = (counts[code] || 0) + 1
      })
      return counts
    },
    overviewMandateLabels () {
      const map = {
        '0': this.$t('mandate.status_mandate_0'),
        '1': this.$t('mandate.status_mandate_1'),
        '3': this.$t('mandate.status_mandate_3'),
        '5': this.$t('mandate.status_mandate_5'),
        '7': this.$t('mandate.status_mandate_7')
      }
      return Object.keys(this.overviewMandateBuckets).map(code => map[code] || code)
    },
    overviewMandateValues () {
      return Object.values(this.overviewMandateBuckets)
    },
    overviewMandateColors () {
      return Object.keys(this.overviewMandateBuckets).map(code => this.statusColorMap[code] || '#9ca3af')
    },
    overviewHasMandateData () {
      return this.overviewMandateValues.some(v => v > 0)
    },
    overviewMandatePieData () {
      return {
        labels: this.overviewMandateLabels,
        datasets: [{ data: this.overviewMandateValues, backgroundColor: this.overviewMandateColors }]
      }
    },
    statusOptions () {
      const type = this.mainTabIndex === 0
        ? 'status_mandate'
        : 'status_collection'

      const statuses = [...new Set(
        this.activeStats
          .map(item => item.status ?? item.Status)
          .filter(status => status !== null && status !== undefined && status !== '')
          .map(status => String(status))
      )]

      return statuses
        .sort((a, b) => Number(a) - Number(b))
        .map(status => ({
          value: status,
          label: `mandate.${type}_${status}`
        }))
    },
    statusColorMap () {
      if (this.mainTabIndex === 0) {
        // Mandate status
        return {
          '0': '#F59E0B', // Créé / En attente de signature - orange
          '1': '#16A34A', // Accepté et signé - vert
          '2': '#DC2626', // Rejeté par le débiteur - rouge
          '3': '#2563EB', // Envoyé au PSP du débiteur - bleu
          '4': '#7A0020', // Rejeté par le PSP - rouge/rose
          '5': '#0D9488', // Mandat validé - turquoise
          '6': '#8B5CF6', // En attente de nouvelle signature - violet
          '7': '#64748B', // Annulé / Clos - gris
          '10': '#7C3AED' // Expiré - violet foncé
        }
      }

      // Collection status
      return {
        '1': '#3B82F6',  // Créé - bleu
        '2': '#06B6D4',  // Envoyé - cyan
        '3': '#F97316',  // Erreur métier - orange
        '4': '#DC2626',  // Erreur technique - rouge
        '5': '#F59E0B',  // Reçu (en attente) - ambre
        '6': '#7A0020',  // Rejeté - rouge/rose
        '7': '#16A34A',  // Payé - vert
        '8': '#8B5CF6',  // Remboursé - violet
        '9': '#64748B',  // Annulé - gris
        '10': '#7C3AED'  // Retourné - violet foncé
      }
    },
    pieBuckets () {
      const counts = {}
      this.activeStats.forEach(item => {
        const code = String(item.status ?? item.Status ?? '')
        counts[code] = (counts[code] || 0) + 1
      })
      return counts
    },
    currentLabels () {
      const type = this.mainTabIndex === 0
        ? 'status_mandate'
        : 'status_collection'

      return Object.keys(this.pieBuckets).map(code =>
        this.$t(`mandate.${type}_${code}`)
      )
    },
    currentValues () {
      return Object.values(this.pieBuckets)
    },
    currentColors () {
      return Object.keys(this.pieBuckets).map(code => this.statusColorMap[code] || '#9ca3af')
    },
    hasData () {
      return this.currentValues.some(v => v > 0)
    },
    currentPieData () {
      return {
        labels: this.currentLabels,
        datasets: [{
          data: this.currentValues,
          backgroundColor: this.currentColors
        }]
      }
    },
    filteredEntityStats () {
      if (this.entityFilter === 'All') return this.entityVolumeStats
      return this.entityVolumeStats.filter(row => row.entity === this.entityFilter)
    },
    entityVolumeChartData () {
      return {
        labels: this.filteredEntityStats.map(row => row.entity),
        datasets: [
          {
            label: 'Count',
            data: this.filteredEntityStats.map(row => row.count),
            backgroundColor: 'rgba(23, 132, 135, 0.75)'
          }
        ]
      }
    },
    entityTableFields () {
      return [
        { key: 'entity', label: 'Entité SNCF', sortable: true },
        { key: 'count', label: 'Count', sortable: true },
        { key: 'amountLabel', label: 'Total amount', sortable: true }
      ]
    },
    entityTableItems () {
      return this.filteredEntityStats.map(row => ({
        ...row,
        amountLabel: row.amount.toLocaleString('en-US', { style: 'currency', currency: 'EUR' })
      }))
    },
    filteredRejectStats () {
      return this.rejectStats.filter(row => this.motifFilter === 'All' || row.motif === this.motifFilter)
    },
    motifBuckets () {
      // Initialise tous les codes connus à 0 afin qu'ils restent visibles
      // dans le graphique même lorsqu'aucune R-transaction ne porte ce motif.
      const buckets = {}
      this.motifOptions.forEach(item => {
        buckets[item.code] = 0
      })

      this.filteredRejectStats.forEach(row => {
        // Conserve aussi un éventuel code retourné par le backend qui ne serait
        // pas encore présent dans motifOptions.
        if (!(row.motif in buckets)) buckets[row.motif] = 0
        buckets[row.motif] += Number(row.count) || 0
      })

      return buckets
    },
    motifChartData () {
      const codes = Object.keys(this.motifBuckets)
      const labels = codes.map(code => {
        const row = this.filteredRejectStats.find(item => item.motif === code)
        return row && row.motifLabel ? `${code} - ${row.motifLabel}` : code
      })
      return {
        labels,
        datasets: [{
          label: 'Rejects',
          data: codes.map(code => this.motifBuckets[code]),
          backgroundColor: 'rgba(239, 68, 68, 0.75)'
        }]
      }
    },
    emitterBuckets () {
      const buckets = {}
      this.filteredRejectStats.forEach(row => {
        buckets[row.emitter] = (buckets[row.emitter] || 0) + row.count
      })
      return buckets
    },
    hasÉmetteurData () {
      return Object.values(this.emitterBuckets).some(v => v > 0)
    },
    emitterPieData () {
      const labels = Object.keys(this.emitterBuckets)
      const palette = ['#178487', '#f59e0b', '#3b82f6', '#ef4444', '#16a34a', '#9333ea']
      return {
        labels,
        datasets: [{
          data: Object.values(this.emitterBuckets),
          backgroundColor: labels.map((_, idx) => palette[idx % palette.length])
        }]
      }
    },
    rejectKpis () {
      const rows = this.filteredRejectStats
      const total = rows.reduce((sum, row) => sum + row.count, 0)
      const totalMandates = this.entityVolumeStats.reduce((sum, row) => sum + row.count, 0)
      const rate = totalMandates ? ((total / totalMandates) * 100).toFixed(1) : '0.0'
      let topMotif = 'N/A'
      const buckets = this.motifBuckets
      const topCode = Object.keys(buckets).sort((a, b) => buckets[b] - buckets[a])[0]
      if (topCode) {
        const found = this.motifOptions.find(m => m.code === topCode)
        topMotif = found ? `${found.code} - ${found.label}` : topCode
      }
      return { total, rate, topMotif }
    },
    rejectTableFields () {
      return [
        { key: 'date', label: 'Date', sortable: true },
        { key: 'emitter', label: 'Émetteur', sortable: true },
        { key: 'motif', label: 'code de retour', sortable: true },
        { key: 'motifLabel', label: 'Motif', sortable: true },
        { key: 'count', label: 'Count', sortable: true },
        { key: 'amountLabel', label: 'Montant', sortable: true }
      ]
    },
    rejectTableItems () {
      return this.filteredRejectStats.map(row => ({
        ...row,
        amountLabel: row.amount.toLocaleString('en-US', { style: 'currency', currency: 'EUR' })
      }))
    },
    representationTableFields () {
      return [
        { key: 'reason', label: 'Reject reason (initial)', sortable: true },
        { key: 'attempts', label: 'Representation attempts', sortable: true },
        { key: 'successes', label: 'Successes', sortable: true },
        { key: 'successRate', label: 'Taux de réussite', sortable: true }
      ]
    },
    representationTableItems () {
      return this.representationStats.map(row => {
        const rate = row.attempts ? (row.successes / row.attempts) * 100 : 0
        return {
          ...row,
          successRateValue: rate,
          successRate: rate.toFixed(1) + ' %'
        }
      })
    },
    representationVariant () {
      return (rate) => {
        if (rate >= 50) return 'success'
        if (rate >= 25) return 'warning'
        return 'danger'
      }
    },
    recoveryKpis () {
      const { totalUnpaid, totalUnpaidAmount, recovered, avgDelayDays } = this.recoveryStats
      const rate = totalUnpaid ? ((recovered / totalUnpaid) * 100).toFixed(1) : '0.0'
      return {
        rate,
        avgDelayDays,
        unpaidAmountLabel: totalUnpaidAmount.toLocaleString('en-US', { style: 'currency', currency: 'EUR' })
      }
    },
    auditTableFields () {
      return [
        { key: 'action', label: 'Action', sortable: true },
        { key: 'count', label: 'Occurrences / période', sortable: true },
        { key: 'user', label: 'Initié par', sortable: true },
        { key: 'lastEvent', label: 'Dernier événement', sortable: true }
      ]
    },
    auditTableItems () {
      return this.auditStats
    },
    fraudKpis () {
      const rows = this.fraudStats
      const totalCount = rows.length
      const totalAmount = rows.reduce((sum, r) => sum + r.amount, 0)
      const totalMandates = this.entityVolumeStats.reduce((sum, r) => sum + r.count, 0)
      const sncfCount = rows.filter(r => r.detectedBy === 'SNCF').length
      const bankCount = rows.filter(r => r.detectedBy === 'Bank').length
      return {
        totalCount,
        totalAmountLabel: totalAmount.toLocaleString('en-US', { style: 'currency', currency: 'EUR' }),
        fraudRate: totalMandates ? ((totalCount / totalMandates) * 100).toFixed(2) : '0.00',
        sncfCount,
        bankCount
      }
    },
    fraudTableFields () {
      return [
        { key: 'date', label: 'Date', sortable: true },
        { key: 'type', label: 'Nature de la fraude', sortable: true },
        { key: 'entity', label: 'Entité SNCF', sortable: true },
        { key: 'detectedBy', label: 'Détecté par', sortable: true },
        { key: 'amountLabel', label: 'Montant', sortable: true },
        { key: 'severity', label: 'Sévérité', sortable: true }
      ]
    },
    fraudTableItems () {
      return this.fraudStats.map(row => ({
        ...row,
        amountLabel: row.amount.toLocaleString('en-US', { style: 'currency', currency: 'EUR' })
      }))
    },

    filteredTechLog () {
      return this.techJourneyLog.filter(row => {
        const matchType = this.journeyTypeFilter === 'All' || row.journeyType === this.journeyTypeFilter
        const matchStatus = this.techStatusFilter === 'All' || row.status === this.techStatusFilter
        return matchType && matchStatus
      })
    },
    techLogKpis () {
      const rows = this.filteredTechLog
      const totalSuccess = rows.reduce((sum, r) => sum + r.successCount, 0)
      const totalÉchec = rows.reduce((sum, r) => sum + (r.status === 'Échec' ? r.ÉchecCount : 0), 0)
      const total = totalSuccess + totalÉchec
      const causesCount = {}
      rows.filter(r => r.status === 'Échec').forEach(r => {
        causesCount[r.technicalCause] = (causesCount[r.technicalCause] || 0) + r.ÉchecCount
      })
      const topCauseKey = Object.keys(causesCount).sort((a, b) => causesCount[b] - causesCount[a])[0]
      return {
        total: total.toLocaleString('en-US'),
        successRate: total ? ((totalSuccess / total) * 100).toFixed(1) : '0.0',
        ÉchecCount: totalÉchec.toLocaleString('en-US'),
        topCause: topCauseKey || 'N/A'
      }
    },
    techJourneyChartData () {
      const steps = [...new Set(this.filteredTechLog.map(r => r.step))]
      return {
        labels: steps,
        datasets: [
          {
            label: 'Success',
            data: steps.map(step => this.filteredTechLog.filter(r => r.step === step && r.status === 'Success').reduce((sum, r) => sum + r.successCount, 0)),
            backgroundColor: 'rgba(22, 163, 74, 0.75)'
          },
          {
            label: 'Échec',
            data: steps.map(step => this.filteredTechLog.filter(r => r.step === step && r.status === 'Échec').reduce((sum, r) => sum + r.ÉchecCount, 0)),
            backgroundColor: 'rgba(239, 68, 68, 0.75)'
          }
        ]
      }
    },
    techLogTableFields() {
      return [
        { key: 'step', label: 'Étape', sortable: true },
        { key: 'journeyType', label: 'Type de parcours', sortable: true },
        { key: 'errorCode', label: 'Code d’erreur', sortable: true },
        { key: 'technicalCause', label: 'Cause technique', sortable: true },
        { key: 'functionalCause', label: 'Cause fonctionnelle', sortable: true },
        { key: 'status', label: 'Statut', sortable: true },
        { key: 'timestamp', label: 'Date', sortable: true }
      ]
    },
    techLogTableItems() {
      // on ne garde que les lignes d'echec en detail (les succes sont deja visibles dans le chart au-dessus)
      return this.filteredTechLog
        .filter(row => row.status === 'Échec')
        .map(row => ({
          ...row,
          technicalCause: row.technicalCause || '-',
          functionalCause: row.functionalCause || '-'
        }))
    },
    filteredUnpaidReject () {
      return this.unpaidRejectStats.filter(row => {
        // const matchFraud = this.fraudFilter === 'All' ||
        //   (this.fraudFilter === 'Fraude' && row.isFraud) ||
        //   (this.fraudFilter === 'NoFraud' && !row.isFraud)
        const matchRecurring = this.recurringFilter === 'All' ||
          (this.recurringFilter === 'Récurrent' && row.isRecurring) ||
          (this.recurringFilter === 'OneOff' && !row.isRecurring)
        return matchRecurring
      })
    },
    unpaidRejectKpis () {
      const rows = this.filteredUnpaidReject
      const totalCount = rows.reduce((sum, r) => sum + r.count, 0)
      const totalAmount = rows.reduce((sum, r) => sum + r.amount, 0)
      const fraudCount = rows.filter(r => r.isFraud).reduce((sum, r) => sum + r.count, 0)
      const recurringCount = rows.filter(r => r.isRecurring).reduce((sum, r) => sum + r.count, 0)
      const totalMandates = this.entityVolumeStats.reduce((sum, r) => sum + r.count, 0)
      return {
        totalCount: totalCount.toLocaleString('en-US'),
        totalAmountLabel: totalAmount.toLocaleString('en-US', { style: 'currency', currency: 'EUR' }),
        rejectRate: totalMandates ? ((totalCount / totalMandates) * 100).toFixed(1) : '0.0',
        fraudRate: totalCount ? ((fraudCount / totalCount) * 100).toFixed(1) : '0.0',
        recurringRate: totalCount ? ((recurringCount / totalCount) * 100).toFixed(1) : '0.0'
      }
    },
    natureBuckets () {
      const buckets = {}
      this.filteredUnpaidReject.forEach(row => {
        buckets[row.nature] = (buckets[row.nature] || 0) + row.count
      })
      return buckets
    },
    natureChartData () {
      return {
        labels: Object.keys(this.natureBuckets),
        datasets: [{
          label: 'Count',
          data: Object.values(this.natureBuckets),
          backgroundColor: 'rgba(239, 68, 68, 0.75)'
        }]
      }
    },
    followUpBuckets () {
      const buckets = {}
      this.filteredUnpaidReject.forEach(row => {
        buckets[row.followUp] = (buckets[row.followUp] || 0) + row.count
      })
      return buckets
    },
    followUpChartData () {
      const labels = Object.keys(this.followUpBuckets)
      const palette = ['#178487', '#f59e0b', '#3b82f6', '#ef4444']
      return {
        labels,
        datasets: [{
          data: Object.values(this.followUpBuckets),
          backgroundColor: labels.map((_, idx) => palette[idx % palette.length])
        }]
      }
    },
    unpaidRejectTableFields () {
      return [
        { key: 'date', label: 'Date', sortable: true },
        { key: 'nature', label: 'Nature', sortable: true },
        { key: 'motif', label: 'Motif (code de retour)', sortable: true },
        { key: 'count', label: 'Count', sortable: true },
        { key: 'amountLabel', label: 'Montant', sortable: true },
        { key: 'emitter', label: 'Émetteur', sortable: true },
        { key: 'incidentType', label: 'Type d’incident', sortable: true },
        //{ key: 'fraudLabel', label: 'Fraude', sortable: true },
        { key: 'recurringLabel', label: 'Recurring', sortable: true },
        { key: 'followUp', label: 'Suivi', sortable: true }
      ]
    },
    unpaidRejectTableItems () {
      return this.filteredUnpaidReject.map(row => ({
        ...row,
        amountLabel: row.amount.toLocaleString('en-US', { style: 'currency', currency: 'EUR' }),
        fraudLabel: row.isFraud ? 'Oui' : 'Non',
        recurringLabel: row.isRecurring ? 'Oui' : 'Non'
      }))
    },
    fraudSeverityVariant () {
      return (severity) => {
        switch (severity) {
          case 'Élevée': return 'danger'
          case 'Moyenne': return 'warning'
          default: return 'secondary'
        }
      }
    },
    signatureErrorKpis () {
      const rows = this.signatureErrorStats
      const failedAttempts = rows.reduce((sum, row) => sum + row.count, 0)
      const totalAttempts = 2480
      const mainIssueRow = rows.reduce((max, row) => row.count > max.count ? row : max, rows[0])
      const autoResolvedCount = rows
        .filter(row => row.status === 'Résolu automatiquement' || row.status === 'Résolu')
        .reduce((sum, row) => sum + row.count, 0)
      const weightedResolution = rows.reduce((sum, row) => sum + (row.count * row.avgResolutionMin), 0)
      const channelCounts = rows.reduce((acc, row) => {
        acc[row.channel] = (acc[row.channel] || 0) + row.count
        return acc
      }, {})
      const channels = Object.keys(channelCounts)
      const mainChannel = channels.reduce((max, channel) =>
        channelCounts[channel] > channelCounts[max] ? channel : max
      , channels[0])

      return {
        totalAttempts: totalAttempts.toLocaleString('en-US'),
        failedAttempts: failedAttempts.toLocaleString('en-US'),
        ÉchecRate: ((failedAttempts / totalAttempts) * 100).toFixed(1),
        mainIssue: mainIssueRow.errorType,
        autoResolved: ((autoResolvedCount / failedAttempts) * 100).toFixed(1),
        agentAction: rows.filter(row => row.status === 'Action requise').reduce((sum, row) => sum + row.count, 0),
        mainChannel,
        avgResolutionTime: Math.round(weightedResolution / failedAttempts) + ' min'
      }
    },
    signatureErrorChartData () {
      return {
        labels: this.signatureErrorStats.map(row => row.errorType),
        datasets: [{
          label: 'Failed signature attempts',
          data: this.signatureErrorStats.map(row => row.count),
          backgroundColor: this.signatureErrorStats.map(row => {
            if (row.severity === 'Élevée') return 'rgba(239, 68, 68, 0.80)'
            if (row.severity === 'Moyenne') return 'rgba(245, 158, 11, 0.80)'
            return 'rgba(59, 130, 246, 0.75)'
          })
        }]
      }
    },
    signatureErrorTableFields () {
      return [
        { key: 'errorType', label: 'Type d’erreur', sortable: true },
        { key: 'count', label: 'Tentatives échouées', sortable: true },
        { key: 'severity', label: 'Sévérité', sortable: true },
        { key: 'channel', label: 'Canal de souscription', sortable: true },
        { key: 'userProfile', label: 'Profil utilisateur', sortable: true },
        { key: 'ÉchecStage', label: 'Échec stage', sortable: true },
        { key: 'avgResolution', label: 'Temps moyen de résolution', sortable: true },
        { key: 'status', label: 'Statut', sortable: true },
        { key: 'lastOccurrence', label: 'Dernière occurrence', sortable: true }
      ]
    },
    signatureErrorTableItems () {
      return this.signatureErrorStats.map(row => ({
        ...row,
        avgResolution: row.avgResolutionMin + ' min'
      }))
    },
    journeyKpis () {
      const rows = this.userJourneyStats
      if (!rows.length) {
        return { uniqueUsers: 0, avgTimeMs: 0, avgAbandonmentRate: 0, mainFriction: 'No data' }
      }
      const avgTimeMs = Math.round(rows.reduce((sum, row) => sum + row.avgTimeMs, 0) / rows.length)
      const avgAbandonmentRate = (rows.reduce((sum, row) => sum + row.abandonmentRate, 0) / rows.length).toFixed(1)
      const frictionRows = rows.filter(row => row.status === 'Point de friction')
      const mainFriction = frictionRows.length
        ? `Point de friction detected: ${frictionRows[0].page}`
        : 'Operational / Healthy'
      return {
        uniqueUsers: Math.max(...rows.map(row => row.uniqueUsers)).toLocaleString('en-US'),
        avgTimeMs,
        avgAbandonmentRate,
        mainFriction
      }
    },
    journeyChartData () {
      return {
        labels: this.userJourneyStats.map(row => row.page),
        datasets: [
          {
            label: 'Temps moyen de traitement (ms)',
            data: this.userJourneyStats.map(row => row.avgTimeMs),
            backgroundColor: 'rgba(59, 130, 246, 0.75)'
          },
          {
            label: 'Taux d’abandon (%)',
            data: this.userJourneyStats.map(row => row.abandonmentRate),
            backgroundColor: 'rgba(239, 68, 68, 0.75)'
          }
        ]
      }
    },
    journeyTableFields () {
      return [
        { key: 'page', label: 'Page / Étape', sortable: true },
        { key: 'Views', label: 'Vues', sortable: true },
        { key: 'uniqueUsers', label: 'Utilisateurs uniques', sortable: true },
        { key: 'avgTime', label: 'Temps moyen de traitement', sortable: true },
        { key: 'abandonmentRate', label: 'Taux d’abandon', sortable: true },
        { key: 'successRate', label: 'Taux de réussite', sortable: true },
        { key: 'errors', label: 'Erreurs', sortable: true },
        { key: 'status', label: 'Statut', sortable: true },
        { key: 'nextStep', label: 'Étape suivante' }
      ]
    },
    journeyTableItems () {
      return this.userJourneyStats.map(row => ({
        ...row,
        views: row.views.toLocaleString('en-US'),
        uniqueUsers: row.uniqueUsers.toLocaleString('en-US'),
        avgTime: this.formatDuration(row.avgTimeMs),
        abandonmentRateValue: row.abandonmentRate,
        abandonmentRate: row.abandonmentRate.toFixed(1) + ' %',
        successRate: row.successRate.toFixed(1) + ' %'
      }))
    }
  },
  watch: {
    mainTabIndex () {
      this.fetchStats()
    }
  },
  methods: {
    goToFraudCase (row) {
      if (!row || row.caseId === undefined || row.caseId === null) {
        console.error('caseId manquant :', row)
        return
      }

      this.$f7.mainView.router.load({
        url: '/fraud-case/' + row.caseId
      })
    },
    collectionStatusLabel (status) {
      const code = String(status ?? '')

      return this.$t(
        `mandate.status_collection_${code}`
      )
    },

    formatCollectionDate (value) {
      if (!value) return ''

      const date = moment(value)

      return date.isValid()
        ? date.format('YYYY-MM-DD HH:mm:ss')
        : value
    },

    exportDashboardCollectionCsv () {
      const that = this

      this.activateSpinner = true

      const statusValue =
        this.statusFilter === 'All'
          ? ''
          : this.statusFilter || ''

      const params = {
        type: 2,
        Status: statusValue,
        StartDueDate: this.dateBeginFilter,
        EndDueDate: this.dateEndFilter,
        firstIndex: 1,

        // Comme Mandat :
        // récupérer toutes les collections pour l'export
        export: 1
      }

      this.$engine.Reporting.getReporting(params)
        .then(resp => {
          const payload = (resp && resp.data) || {}

          const collections =
            Array.isArray(payload.Collection)
              ? payload.Collection
              : []

          // ID 1, 2, 3, 4...
          collections.sort(
            (a, b) =>
              Number(a.IdCollection) -
              Number(b.IdCollection)
          )

          if (!collections.length) {
            this.$f7.alert(
              '',
              'No collection to export'
            )

            return
          }

          this.$f7.showPreloader(
            this.$i18n.t(
              'common.loading_page_label'
            )
          )

          const escapeCsv = value => {
            const stringValue =
              value === null ||
              value === undefined
                ? ''
                : String(value)

            return `"${stringValue.replace(/"/g, '""')}"`
          }

          const headers = [
            'Collection ID',
            'Mandate ID',
            'Unique Mandate Reference',
            'End To End ID',
            'Amount',
            'Due Date',
            'Settlement Date',
            'Debit Date',
            'Status',
            'Direction',
            'Mandate Type',
            'Transaction Type',
            'Schema',

            'Creditor Name',
            'Creditor ID',
            'Creditor Address',
            'Creditor City',
            'Creditor Country',
            'Creditor IBAN',
            'Creditor PSP BIC',

            'Debtor Name',
            'Debtor IBAN',
            'Debtor PSP BIC',

            'Creation Date',

            'Remittance Information',
            'Purpose',
            'Purpose Category',

            'Creditor Reference',
            'Creditor Reference Name',
            'Creditor Collection Reference',

            'Rejection Code',
            'Rejection Reason',

            'Bulk ID'
          ]

          const rows = collections.map(
            collection => [
              collection.IdCollection,
              collection.IdMandate,
              collection.UMR,
              collection.EndToEndId,

              collection.Amount,

              collection.DueDate,
              collection.SettlementDate,
              collection.DebitDate,

              this.collectionStatusLabel(
                collection.Status
              ),

              collection.Direction,
              collection.TypeMandate,
              collection.TypeTransaction,
              collection.SchemaCode,

              collection.CdtrName,
              collection.CdtrId,
              collection.CdtrAddr,
              collection.CdtrCity,
              collection.CdtrCountry,
              collection.CdtrIBAN,
              collection.CdtrPSPBIC,

              collection.DbtrName,
              collection.DbtrIBAN,
              collection.DbtrPSPBIC,

              this.formatCollectionDate(
                collection.CreationDate
              ),

              collection.RemittanceInfo,
              collection.Purpose,
              collection.PurposeCategory,

              collection.CdtrRef,
              collection.CdtrRefName,
              collection.CdtrRefCollection,

              collection.RejectionCode,
              collection.RejectionReason,

              collection.IdCollectionBulk
            ]
          )

          const data = [
            headers
              .map(escapeCsv)
              .join(';'),

            ...rows.map(
              row =>
                row
                  .map(escapeCsv)
                  .join(';')
            )
          ].join('\r\n')

          this.$f7.hidePreloader()

          // Même mécanisme que ton export Mandat
          // et MandateTransactionsUnit
          const linkSource =
            'data:text/csv;charset:utf-8;base64,' +
            btoa(
              unescape(
                encodeURIComponent(data)
              )
            )

          const downloadLink =
            document.createElement('a')

          const fileName =
            'collections_' +
            moment().format(
              'YYYYMMDD_HHmmss'
            ) +
            '.csv'

          downloadLink.href = linkSource
          downloadLink.download = fileName

          downloadLink.click()

          this.$f7.alert(
            '',
            this.$i18n.t(
              'common.exprt_succ'
            )
          )
        })
        .catch(error => {
          this.$f7.hidePreloader()

          errorMessageAlert(
            error,
            that
          )
        })
        .finally(() => {
          this.activateSpinner = false
        })
    },
    exportDashboardCollectionPdf () {
      const that = this

      this.activateSpinner = true

      const statusValue =
        this.statusFilter === 'All'
          ? ''
          : this.statusFilter || ''

      const params = {
        type: 2,
        Status: statusValue,
        StartDueDate: this.dateBeginFilter,
        EndDueDate: this.dateEndFilter,
        firstIndex: 1,
        export: 1
      }

      this.$engine.Reporting.getReporting(params)
        .then(resp => {
          const payload =
            (resp && resp.data) || {}

          const collections =
            Array.isArray(payload.Collection)
              ? payload.Collection
              : []

          collections.sort(
            (a, b) =>
              Number(a.IdCollection) -
              Number(b.IdCollection)
          )

          if (!collections.length) {
            this.$f7.alert(
              '',
              'No collection to export'
            )

            return
          }

          /*
           * Pour Collection ton response actuel ne contient
           * pas crt_info.
           *
           * On utilise donc crtInfo déjà chargé par le dashboard
           * Mandat si disponible.
           */
          const info = this.crtInfo || {}

          this.buildDashboardCollectionPdf(
            collections,
            info
          )
        })
        .catch(error => {
          errorMessageAlert(
            error,
            that
          )
        })
        .finally(() => {
          this.activateSpinner = false
        })
    },

    buildDashboardCollectionPdf (
      collections,
      info
    ) {
      try {
        const doc = new jsPDF({
          orientation: 'landscape',
          unit: 'mm',
          format: 'a4'
        })

        const pageWidth =
          doc.internal.pageSize.getWidth()

        const pageHeight =
          doc.internal.pageSize.getHeight()

        // ============================================
        // PAGE 1 - COVER
        // ============================================

        // Petit titre en haut
        doc.setFont('helvetica', 'normal')
        doc.setFontSize(11)
        doc.setTextColor(110, 110, 110)

        doc.text(
          'COLLECTION MANAGEMENT',
          pageWidth / 2,
          30,
          { align: 'center' }
        )

        // Titre principal
        doc.setFont('helvetica', 'bold')
        doc.setFontSize(30)
        doc.setTextColor(40, 55, 70)

        doc.text(
          'Collection Dashboard Report',
          pageWidth / 2,
          52,
          { align: 'center' }
        )

        // Ligne
        doc.setDrawColor(92, 171, 174)
        doc.setLineWidth(1)
        doc.line(
          pageWidth / 2 - 35,
          61,
          pageWidth / 2 + 35,
          61
        )

        // Nom entreprise
        doc.setFont('helvetica', 'bold')
        doc.setFontSize(22)
        doc.setTextColor(50, 50, 50)

        doc.text(
          info.cdtr_name || '-',
          pageWidth / 2,
          84,
          { align: 'center' }
        )

        // Adresse
        doc.setFont('helvetica', 'normal')
        doc.setFontSize(11)
        doc.setTextColor(100, 100, 100)

        const address = [
          info.cdtr_address,
          info.cdtr_city,
          info.cdtr_country
        ]
          .filter(Boolean)
          .join(', ')

        doc.text(
          address || '-',
          pageWidth / 2,
          94,
          { align: 'center' }
        )

        // Bloc utilisateur
        const boxWidth = 105
        const boxHeight = 42
        const boxX = (pageWidth - boxWidth) / 2
        const boxY = 112

        doc.setFillColor(247, 249, 250)
        doc.setDrawColor(225, 230, 235)

        doc.roundedRect(
          boxX,
          boxY,
          boxWidth,
          boxHeight,
          3,
          3,
          'FD'
        )

        doc.setFont('helvetica', 'bold')
        doc.setFontSize(10)
        doc.setTextColor(100, 100, 100)

        doc.text(
          'REPORT GENERATED BY',
          pageWidth / 2,
          boxY + 10,
          { align: 'center' }
        )

        doc.setFont('helvetica', 'bold')
        doc.setFontSize(14)
        doc.setTextColor(50, 50, 50)

        doc.text(
          info.user_name || '-',
          pageWidth / 2,
          boxY + 22,
          { align: 'center' }
        )

        doc.setFont('helvetica', 'normal')
        doc.setFontSize(10)
        doc.setTextColor(100, 100, 100)

        doc.text(
          info.user_login || '-',
          pageWidth / 2,
          boxY + 31,
          { align: 'center' }
        )

        // Date génération
        doc.setFontSize(9)
        doc.setTextColor(130, 130, 130)

        doc.text(
          `Generated on ${moment().format('YYYY-MM-DD HH:mm:ss')}`,
          pageWidth / 2,
          pageHeight - 20,
          { align: 'center' }
        )

        // ============================================
        // CALCUL DES STATS SUR LES DONNÉES EXPORTÉES
        // ============================================

        const totalCount =
          collections.length

        const totalAmount =
          collections.reduce(
            (sum, item) =>
              sum +
              Number(item.Amount || 0),
            0
          )

        const paid =
          collections.filter(
            item =>
              String(item.Status) === '7'
          )

        const rejected =
          collections.filter(
            item =>
              String(item.Status) === '6'
          )

        const errors =
          collections.filter(
            item =>
              ['3', '4'].includes(
                String(item.Status)
              )
          )

        const paidAmount =
          paid.reduce(
            (sum, item) =>
              sum +
              Number(item.Amount || 0),
            0
          )

        const rate = count =>
          totalCount
            ? (
                count /
                totalCount *
                100
              ).toFixed(1)
            : '0.0'

        // ============================================
        // PAGE 2 - STATISTICS
        // ============================================

        doc.addPage()

        doc.setFont(
          'helvetica',
          'bold'
        )

        doc.setFontSize(20)

        doc.setTextColor(
          40,
          55,
          70
        )

        doc.text(
          'Collection Statistics',
          pageWidth / 2,
          18,
          {
            align: 'center'
          }
        )

        const summaryRows = [
          [
            'Total collections',
            totalCount
          ],
          [
            'Total amount',
            `${totalAmount.toFixed(2)} EUR`
          ],
          [
            'Paid amount',
            `${paidAmount.toFixed(2)} EUR`
          ],
          [
            'Payment rate',
            `${rate(paid.length)} %`
          ],
          [
            'Rejection rate',
            `${rate(rejected.length)} %`
          ],
          [
            'Error rate',
            `${rate(errors.length)} %`
          ]
        ]

        autoTable(doc, {
          startY: 30,

          head: [[
            'Indicator',
            'Value'
          ]],

          body: summaryRows,

          theme: 'grid',

          styles: {
            fontSize: 10,
            cellPadding: 3
          },

          headStyles: {
            fillColor: [
              92,
              171,
              174
            ],

            textColor: 255,

            fontStyle: 'bold'
          },

          margin: {
            left: 85,
            right: 85
          }
        })

        // ============================================
        // STATS PAR STATUS
        // ============================================

        const statusStats = {}

        collections.forEach(
          collection => {
            const status =
              String(
                collection.Status || ''
              )

            if (!statusStats[status]) {
              statusStats[status] = {
                count: 0,
                amount: 0
              }
            }

            statusStats[status].count++

            statusStats[status].amount +=
              Number(
                collection.Amount || 0
              )
          }
        )

        const statusRows =
          Object.keys(statusStats)
            .sort(
              (a, b) =>
                Number(a) -
                Number(b)
            )
            .map(status => {
              const item =
                statusStats[status]

              return [
                this.collectionStatusLabel(
                  status
                ),

                item.count,

                `${item.amount.toFixed(2)} EUR`,

                `${rate(item.count)} %`
              ]
            })

        autoTable(doc, {
          startY:
            doc.lastAutoTable.finalY + 10,

          head: [[
            'Status',
            'Collections',
            'Amount',
            'Percentage'
          ]],

          body: statusRows,

          theme: 'grid',

          styles: {
            fontSize: 9,
            cellPadding: 3,
            halign: 'center'
          },

          headStyles: {
            fillColor: [
              92,
              171,
              174
            ],

            textColor: 255,

            fontStyle: 'bold'
          },

          margin: {
            left: 55,
            right: 55
          }
        })

        // ============================================
        // PAGE 3 - COLLECTION LIST
        // ============================================

        doc.addPage()

        doc.setFont(
          'helvetica',
          'bold'
        )

        doc.setFontSize(18)

        doc.setTextColor(
          40,
          55,
          70
        )

        doc.text(
          'Collection List',
          pageWidth / 2,
          16,
          {
            align: 'center'
          }
        )

        doc.setFont(
          'helvetica',
          'normal'
        )

        doc.setFontSize(9)

        doc.setTextColor(
          110,
          110,
          110
        )

        doc.text(
          `${collections.length} collection(s)`,
          pageWidth / 2,
          23,
          {
            align: 'center'
          }
        )

        const tableRows =
          collections.map(c => [
            c.IdCollection || '',
            c.UMR || '',
            c.DbtrName || '',
            c.DbtrIBAN || '',

            Number(c.Amount || 0)
              .toFixed(2) +
              ' EUR',

            c.DueDate || '',

            this.collectionStatusLabel(
              c.Status
            ),

            c.SchemaCode || '',

            c.EndToEndId || ''
          ])

        autoTable(doc, {
          startY: 30,

          head: [[
            'ID',
            'UMR',
            'Debtor',
            'IBAN',
            'Amount',
            'Due date',
            'Status',
            'Schema',
            'End To End ID'
          ]],

          body: tableRows,

          theme: 'grid',

          styles: {
            fontSize: 6.5,
            cellPadding: 1.7,
            valign: 'middle',
            overflow: 'linebreak'
          },

          headStyles: {
            fillColor: [
              92,
              171,
              174
            ],

            textColor: 255,

            fontStyle: 'bold',

            halign: 'center'
          },

          columnStyles: {
            0: {
              cellWidth: 10,
              halign: 'center'
            },

            1: {
              cellWidth: 47
            },

            2: {
              cellWidth: 25
            },

            3: {
              cellWidth: 38
            },

            4: {
              cellWidth: 20,
              halign: 'right'
            },

            5: {
              cellWidth: 22
            },

            6: {
              cellWidth: 31
            },

            7: {
              cellWidth: 15,
              halign: 'center'
            },

            8: {
              cellWidth: 55
            }
          },

          margin: {
            left: 8,
            right: 8
          }
        })

        // ============================================
        // FOOTER
        // ============================================

        const pageCount =
          doc.getNumberOfPages()

        for (
          let page = 2;
          page <= pageCount;
          page++
        ) {
          doc.setPage(page)

          doc.setFontSize(8)

          doc.setTextColor(
            130,
            130,
            130
          )

          doc.text(
            info.cdtr_name || '',
            10,
            pageHeight - 7
          )

          doc.text(
            `Page ${page} / ${pageCount}`,
            pageWidth - 10,
            pageHeight - 7,
            {
              align: 'right'
            }
          )
        }

        const entityName =
          String(
            info.cdtr_name ||
            'collection'
          )
            .replace(
              /[^a-zA-Z0-9_-]/g,
              '_'
            )

        doc.save(
          `${entityName}_collection_dashboard_${moment().format(
            'YYYYMMDD_HHmmss'
          )}.pdf`
        )

        this.$f7.alert(
          '',
          this.$i18n.t(
            'common.exprt_succ'
          )
        )
      } catch (e) {
        console.error(
          'Collection PDF export:',
          e
        )

        errorMessageAlert(
          e,
          this
        )
      }
    },
    chooseDashboardExport (format) {
      this.showExportModal = false

      // Mandate
      if (this.mainTabIndex === 0) {
        if (format === 'pdf') {
          this.exportDashboardMandatePdf()
        } else {
          this.exportDashboardMandateCsv()
        }

        return
      }

      // Collection
      if (this.mainTabIndex === 1) {
        if (format === 'pdf') {
          this.exportDashboardCollectionPdf()
        } else {
          this.exportDashboardCollectionCsv()
        }
        return
      }

      if (this.mainTabIndex === 6) {
        if (format === 'pdf') {
          this.exportRTransactionsPdf()
        } else {
          this.exportRTransactionsCsv()
        }
      }
    },

    formatCollectionAmount (amount) {
      return Number(amount || 0)
        .toLocaleString(
          'fr-FR',
          {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }
        ) + ' €'
    },

    mandateTransactionTypeLabel (type) {
      if (Number(type) === 1) return this.$t('mandate.transaction_type_one_off')
      if (Number(type) === 2) return this.$t('mandate.transaction_type_recurring')
      return type || ''
    },

    mandateStatusLabel (status) {
      const code = String(status ?? '')
      return this.$t(`mandate.status_mandate_${code}`)
    },

    formatMandateDate (value) {
      if (!value) return ''
      const date = moment(value)
      return date.isValid() ? date.format('YYYY-MM-DD HH:mm:ss') : value
    },
    clearFilterFields () {
      this.dateBeginFilter = null
      this.dateEndFilter = null
      this.statusFilter = 'All'
      this.entityFilter = 'All'
      this.motifFilter = 'All'
      this.journeyTypeFilter = 'All'
      this.techStatusFilter = 'All'
      //this.fraudFilter = 'All'
      this.recurringFilter = 'All'
    },
    exportDashboardMandateCsv () {
      const that = this

      this.activateSpinner = true

      const statusValue =
        this.statusFilter === 'All'
          ? ''
          : this.statusFilter || ''

      const params = {
        type: 1,
        dateBegin: this.dateBeginFilter,
        dateEnd: this.dateEndFilter,
        status_mandate: statusValue,
        export: 1
      }

      this.$engine.Reporting.getReporting(params)
        .then(resp => {
          const payload = (resp && resp.data) || {}

          // Avec export=1 : tous les mandats retournés par le backend
          const mandates = Array.isArray(payload.Reporting)
            ? payload.Reporting
            : Array.isArray(payload.reporting)
              ? payload.reporting
              : Array.isArray(payload.Mandates)
                ? payload.Mandates
                : Array.isArray(payload)
                  ? payload
                  : []

          mandates.sort((a, b) =>
            Number(a.id_mandate) - Number(b.id_mandate)
          )

          if (!mandates.length) {
            this.$f7.alert('', 'No mandate to export')
            return
          }

          this.$f7.showPreloader(
            this.$i18n.t('common.loading_page_label')
          )

          // =====================================================
          // HEADER CSV
          // =====================================================

          let firstLine =
            'Mandate ID;' +
            'Unique Mandate Reference;' +
            'Underlying Contract ID;' +
            'Message Type;' +
            'Transaction Type;' +
            'Schema;' +
            'Creditor Name;' +
            'Creditor ID;' +
            'Creditor Address;' +
            'Creditor City;' +
            'Creditor Country;' +
            'Debtor Name;' +
            'Debtor IBAN;' +
            'Debtor Email;' +
            'Debtor ID;' +
            'Debtor Address;' +
            'Debtor City;' +
            'Debtor Country;' +
            'Debtor PSP BIC;' +
            'Creation Date;' +
            'Signing Date;' +
            'Cancellation Date;' +
            'Status;' +
            'Reason;' +
            'Creditor Reference;' +
            'Creditor Reference Name\r\n'

          // =====================================================
          // LIGNES CSV
          // =====================================================

          let lines = ''

          for (let i = 0; i < mandates.length; i++) {
            const mandate = mandates[i]

            lines +=
              (mandate.id_mandate || '') + ';' +
              (mandate.UMR || '') + ';' +
              (mandate.id_contract || '') + ';' +
              (mandate.message_type || '') + ';' +
              this.mandateTransactionTypeLabel(
                mandate.type_transaction
              ) + ';' +
              (mandate.schema_code || '') + ';' +

              (mandate.cdtr_name || '') + ';' +
              (mandate.cdtr_id || '') + ';' +
              (mandate.cdtr_addr || '') + ';' +
              (mandate.cdtr_city || '') + ';' +
              (mandate.cdtr_country || '') + ';' +

              (mandate.dbtr_name || '') + ';' +
              (mandate.dbtr_iban || '') + ';' +
              (mandate.dbtr_email || '') + ';' +
              (mandate.dbtr_id || '') + ';' +
              (mandate.dbtr_addr || '') + ';' +
              (mandate.dbtr_city || '') + ';' +
              (mandate.dbtr_country || '') + ';' +
              (mandate.dbtrPSP_BIC || '') + ';' +

              this.formatMandateDate(
                mandate.creation_date
              ) + ';' +

              this.formatMandateDate(
                mandate.signing_md_date
              ) + ';' +

              this.formatMandateDate(
                mandate.signing_cancel_date
              ) + ';' +

              this.mandateStatusLabel(
                mandate.status
              ) + ';' +

              (mandate.reason_mandate || '') + ';' +
              (mandate.cdtr_ref || '') + ';' +
              (mandate.cdtr_ref_name || '') +
              '\r\n'
          }

          const data = firstLine + lines

          this.$f7.hidePreloader()

          // =====================================================
          // EXACTEMENT COMME MandateTransactionsUnit.vue
          // =====================================================

          const linkSource =
            'data:text/csv;charset:utf-8;base64,' +
            btoa(unescape(encodeURIComponent(data)))

          const downloadLink =
            document.createElement('a')

          const today = moment()

          const fileName =
            'mandates_' +
            today.unix() +
            '.csv'

          downloadLink.href = linkSource
          downloadLink.download = fileName

          // Exactement comme la page Transaction
          downloadLink.click()

          this.$f7.alert(
            '',
            this.$i18n.t('common.exprt_succ')
          )
        })
        .catch(error => {
          this.$f7.hidePreloader()

          errorMessageAlert(
            error,
            that
          )
        })
        .finally(() => {
          this.activateSpinner = false
        })
    },
    dashboardMandateStatusStats () {
      const counts = {}

      this.mandateStats.forEach(m => {
        const code = String(m.status ?? '')
        counts[code] = (counts[code] || 0) + 1
      })

      const total = this.mandateStats.length || 1

      return Object.keys(counts)
        .sort((a, b) => Number(a) - Number(b))
        .map(code => ({
          code,
          label: this.mandateStatusLabel(code),
          count: counts[code],
          percentage: ((counts[code] / total) * 100).toFixed(1)
        }))
    },
    buildDashboardStatusChart (stats) {
      const canvas = document.createElement('canvas')

      canvas.width = 1000
      canvas.height = 400

      const ctx = canvas.getContext('2d')

      if (!ctx) return null

      ctx.fillStyle = '#ffffff'
      ctx.fillRect(0, 0, canvas.width, canvas.height)

      const total = stats.reduce(
        (sum, item) => sum + item.count,
        0
      ) || 1

      const cx = 230
      const cy = 200
      const radius = 155
      const innerRadius = 90

      let startAngle = -Math.PI / 2

      stats.forEach(item => {
        const angle =
          (item.count / total) * Math.PI * 2

        ctx.beginPath()

        ctx.arc(
          cx,
          cy,
          radius,
          startAngle,
          startAngle + angle
        )

        ctx.arc(
          cx,
          cy,
          innerRadius,
          startAngle + angle,
          startAngle,
          true
        )

        ctx.closePath()

        ctx.fillStyle =
          this.statusColorMap[item.code] || '#9CA3AF'

        ctx.fill()

        startAngle += angle
      })

      // Total au centre
      ctx.textAlign = 'center'
      ctx.fillStyle = '#374151'
      ctx.font = 'bold 34px Arial'
      ctx.fillText(String(total), cx, cy)

      ctx.font = '16px Arial'
      ctx.fillStyle = '#6B7280'
      ctx.fillText('Mandates', cx, cy + 28)

      // Légende
      ctx.textAlign = 'left'

      stats.forEach((item, index) => {
        const y = 75 + index * 34

        ctx.fillStyle =
          this.statusColorMap[item.code] || '#9CA3AF'

        ctx.fillRect(500, y - 15, 20, 20)

        ctx.fillStyle = '#374151'
        ctx.font = '16px Arial'

        ctx.fillText(
          `${item.label}: ${item.count} (${item.percentage}%)`,
          535,
          y
        )
      })

      return canvas.toDataURL('image/png')
    },

    exportDashboardMandatePdf () {
      try {
        const mandates = this.mandateStats || []
        const info = this.crtInfo || {}

        const doc = new jsPDF({
          orientation: 'landscape',
          unit: 'mm',
          format: 'a4'
        })

        const pageWidth = doc.internal.pageSize.getWidth()
        const pageHeight = doc.internal.pageSize.getHeight()

        // =====================================================
        // PAGE 1 - PAGE DE GARDE
        // =====================================================

        // Petit titre en haut
        doc.setFont('helvetica', 'normal')
        doc.setFontSize(11)
        doc.setTextColor(110, 110, 110)

        doc.text(
          'MANDATE MANAGEMENT',
          pageWidth / 2,
          30,
          { align: 'center' }
        )

        // Titre principal
        doc.setFont('helvetica', 'bold')
        doc.setFontSize(30)
        doc.setTextColor(40, 55, 70)

        doc.text(
          'Mandate Dashboard',
          pageWidth / 2,
          52,
          { align: 'center' }
        )

        // Ligne
        doc.setDrawColor(92, 171, 174)
        doc.setLineWidth(1)

        doc.line(
          pageWidth / 2 - 35,
          61,
          pageWidth / 2 + 35,
          61
        )

        // Nom entreprise
        doc.setFont('helvetica', 'bold')
        doc.setFontSize(22)
        doc.setTextColor(50, 50, 50)

        doc.text(
          info.cdtr_name || '-',
          pageWidth / 2,
          84,
          { align: 'center' }
        )

        // Adresse
        doc.setFont('helvetica', 'normal')
        doc.setFontSize(11)
        doc.setTextColor(100, 100, 100)

        const address = [
          info.cdtr_address,
          info.cdtr_city,
          info.cdtr_country
        ]
          .filter(Boolean)
          .join(', ')

        doc.text(
          address || '-',
          pageWidth / 2,
          94,
          { align: 'center' }
        )

        // =============================
        // Bloc utilisateur
        // =============================

        const boxWidth = 105
        const boxHeight = 42
        const boxX = (pageWidth - boxWidth) / 2
        const boxY = 112

        doc.setFillColor(247, 249, 250)
        doc.setDrawColor(225, 230, 235)

        doc.roundedRect(
          boxX,
          boxY,
          boxWidth,
          boxHeight,
          3,
          3,
          'FD'
        )

        doc.setFont('helvetica', 'bold')
        doc.setFontSize(10)
        doc.setTextColor(100, 100, 100)

        doc.text(
          'REPORT GENERATED BY',
          pageWidth / 2,
          boxY + 10,
          { align: 'center' }
        )

        doc.setFont('helvetica', 'bold')
        doc.setFontSize(14)
        doc.setTextColor(50, 50, 50)

        doc.text(
          info.user_name || '-',
          pageWidth / 2,
          boxY + 22,
          { align: 'center' }
        )

        doc.setFont('helvetica', 'normal')
        doc.setFontSize(10)
        doc.setTextColor(100, 100, 100)

        doc.text(
          info.user_login || '-',
          pageWidth / 2,
          boxY + 31,
          { align: 'center' }
        )

        // Date génération
        doc.setFontSize(9)
        doc.setTextColor(130, 130, 130)

        doc.text(
          `Generated on ${moment().format('YYYY-MM-DD HH:mm:ss')}`,
          pageWidth / 2,
          pageHeight - 20,
          { align: 'center' }
        )

        // =====================================================
        // PAGE 2 - STATISTIQUES
        // =====================================================

        doc.addPage()

        doc.setFont('helvetica', 'bold')
        doc.setFontSize(20)
        doc.setTextColor(40, 55, 70)

        doc.text(
          'Mandate Statistics',
          pageWidth / 2,
          18,
          { align: 'center' }
        )

        doc.setFont('helvetica', 'normal')
        doc.setFontSize(11)
        doc.setTextColor(100, 100, 100)

        doc.text(
          `${mandates.length} mandate(s)`,
          pageWidth / 2,
          27,
          { align: 'center' }
        )

        const stats = this.dashboardMandateStatusStats()
        const chart = this.buildDashboardStatusChart(stats)

        if (chart) {
          const chartWidth = 220
          const chartHeight = 88

          doc.addImage(
            chart,
            'PNG',
            (pageWidth - chartWidth) / 2,
            38,
            chartWidth,
            chartHeight
          )
        }

        // Petit tableau récapitulatif des statuts
        const statsRows = stats.map(item => [
          item.label,
          item.count,
          `${item.percentage}%`
        ])

        autoTable(doc, {
          startY: 135,

          head: [[
            'Status',
            'Number of mandates',
            'Percentage'
          ]],

          body: statsRows,

          theme: 'grid',

          styles: {
            fontSize: 9,
            cellPadding: 3,
            halign: 'center'
          },

          headStyles: {
            fillColor: [92, 171, 174],
            textColor: 255,
            fontStyle: 'bold'
          },

          margin: {
            left: 65,
            right: 65
          }
        })

        // =====================================================
        // PAGE 3 - LISTE DES MANDATS
        // =====================================================

        doc.addPage()

        doc.setFont('helvetica', 'bold')
        doc.setFontSize(18)
        doc.setTextColor(40, 55, 70)

        doc.text(
          'Mandate List',
          pageWidth / 2,
          16,
          { align: 'center' }
        )

        doc.setFont('helvetica', 'normal')
        doc.setFontSize(9)
        doc.setTextColor(110, 110, 110)

        doc.text(
          `${mandates.length} mandate(s)`,
          pageWidth / 2,
          23,
          { align: 'center' }
        )

        const tableRows = mandates.map(m => [
          m.UMR || '',
          m.id_contract || '',
          m.dbtr_name || '',
          m.dbtr_iban || '',
          this.mandateTransactionTypeLabel(m.type_transaction),
          m.schema_code || '',
          this.mandateStatusLabel(m.status),
          this.formatMandateDate(m.creation_date)
        ])

        autoTable(doc, {
          startY: 30,

          head: [[
            'UMR',
            'Contract ID',
            'Debtor',
            'IBAN',
            'Transaction type',
            'Schema',
            'Status',
            'Creation date'
          ]],

          body: tableRows,

          theme: 'grid',

          styles: {
            fontSize: 7,
            cellPadding: 2,
            valign: 'middle',
            overflow: 'linebreak'
          },

          headStyles: {
            fillColor: [92, 171, 174],
            textColor: 255,
            fontStyle: 'bold',
            halign: 'center'
          },

          columnStyles: {
            0: { cellWidth: 53 },
            1: { cellWidth: 39 },
            2: { cellWidth: 30 },
            3: { cellWidth: 44 },
            4: { cellWidth: 25 },
            5: { cellWidth: 18, halign: 'center' },
            6: { cellWidth: 34 },
            7: { cellWidth: 32 }
          },

          margin: {
            left: 10,
            right: 10
          }
        })

        // =====================================================
        // FOOTER PAGE 2+
        // =====================================================

        const pageCount = doc.getNumberOfPages()

        for (let page = 2; page <= pageCount; page++) {
          doc.setPage(page)

          doc.setFont('helvetica', 'normal')
          doc.setFontSize(8)
          doc.setTextColor(130, 130, 130)

          doc.text(
            info.cdtr_name || '',
            10,
            pageHeight - 7
          )

          doc.text(
            `Page ${page} / ${pageCount}`,
            pageWidth - 10,
            pageHeight - 7,
            { align: 'right' }
          )
        }

        // =====================================================
        // DOWNLOAD
        // =====================================================

        const entityName = String(info.cdtr_name || 'mandate')
          .replace(/[^a-zA-Z0-9_-]/g, '_')

        doc.save(
          `${entityName}_mandate_dashboard_${moment().format('YYYYMMDD_HHmmss')}.pdf`
        )

        this.$f7.alert(
          '',
          this.$i18n.t('common.exprt_succ')
        )
      } catch (e) {
        errorMessageAlert(this, e)
      }
    },
    exportRTransactionsCsv () {
      try {
        const rows = this.filteredUnpaidReject || []

        if (!rows.length) {
          this.$f7.alert('', 'No R-Transaction to export')
          return
        }

        this.$f7.showPreloader(
          this.$i18n.t('common.loading_page_label')
        )

        const escapeCsv = value => {
          const stringValue =
            value === null || value === undefined
              ? ''
              : String(value)

          return `"${stringValue.replace(/"/g, '""')}"`
        }

        const headers = [
          'Date',
          'R-Transaction Type',
          'Return Code',
          'Return Reason',
          'Collection Status',
          'Transaction Type',
          'Creditor Name',
          'Debtor Name',
          'Debtor IBAN',
          'Amount (EUR)',
          'UMR',
          'End To End ID'
        ]

        const csvRows = rows.map(row => {
          const raw = row.raw || {}

          return [
            row.date || '',
            row.rTransactionType || row.incidentType || '',
            row.motif || '',
            row.motifLabel || row.nature || '',
            row.followUp || '',
            row.isRecurring
              ? this.$t('mandate.transaction_type_recurring')
              : this.$t('mandate.transaction_type_one_off'),
            this.reportingValue(raw, 'cdtr_name', 'CdtrName') || row.emitter || '',
            this.reportingValue(raw, 'dbtr_name', 'DbtrName') || '',
            this.reportingValue(raw, 'dbtr_IBAN', 'DbtrIBAN', 'dbtr_iban') || '',
            Number(row.amount || 0).toFixed(2),
            this.reportingValue(raw, 'UMR', 'umr') || '',
            this.reportingValue(raw, 'end_to_end_id', 'EndToEndId') || ''
          ]
        })

        const data = [
          headers.map(escapeCsv).join(';'),
          ...csvRows.map(row => row.map(escapeCsv).join(';'))
        ].join('\r\n')

        // Même méthode de téléchargement que les exports Mandate / Collection.
        const linkSource =
          'data:text/csv;charset:utf-8;base64,' +
          btoa(unescape(encodeURIComponent(data)))

        const downloadLink = document.createElement('a')
        const fileName =
          'r_transactions_' +
          moment().unix() +
          '.csv'

        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()

        this.$f7.hidePreloader()

        this.$f7.alert(
          '',
          this.$i18n.t('common.exprt_succ')
        )
      } catch (e) {
        this.$f7.hidePreloader()
        errorMessageAlert(e, this)
      }
    },

    buildRTransactionsMotifChartImage () {
      const canvas = document.createElement('canvas')
      canvas.width = 1200
      canvas.height = 520
      const ctx = canvas.getContext('2d')

      ctx.fillStyle = '#FFFFFF'
      ctx.fillRect(0, 0, canvas.width, canvas.height)

      const buckets = this.motifBuckets || {}
      const codes = Object.keys(buckets)
      const values = codes.map(code => Number(buckets[code]) || 0)
      const maxValue = Math.max(1, ...values)

      const left = 80
      const right = 35
      const top = 35
      const bottom = 125
      const chartWidth = canvas.width - left - right
      const chartHeight = canvas.height - top - bottom

      // Grid + Y labels
      ctx.font = '15px Arial'
      ctx.textAlign = 'right'
      ctx.textBaseline = 'middle'

      for (let i = 0; i <= 5; i++) {
        const value = Math.round((maxValue / 5) * i)
        const y = top + chartHeight - (chartHeight * i / 5)

        ctx.strokeStyle = '#E5E7EB'
        ctx.lineWidth = 1
        ctx.beginPath()
        ctx.moveTo(left, y)
        ctx.lineTo(left + chartWidth, y)
        ctx.stroke()

        ctx.fillStyle = '#6B7280'
        ctx.fillText(String(value), left - 12, y)
      }

      const slot = chartWidth / Math.max(codes.length, 1)
      const barWidth = Math.min(90, slot * 0.58)

      codes.forEach((code, index) => {
        const value = values[index]
        const height = (value / maxValue) * chartHeight
        const x = left + index * slot + (slot - barWidth) / 2
        const y = top + chartHeight - height

        ctx.fillStyle = 'rgba(239, 68, 68, 0.75)'
        ctx.fillRect(x, y, barWidth, height)

        ctx.fillStyle = '#374151'
        ctx.font = 'bold 16px Arial'
        ctx.textAlign = 'center'
        ctx.fillText(String(value), x + barWidth / 2, Math.max(top + 12, y - 12))

        const option = this.motifOptions.find(item => item.code === code)
        const matchingRow = this.filteredRejectStats.find(item => item.motif === code)
        const reason = (matchingRow && matchingRow.motifLabel) ||
          (option && option.label) || ''

        ctx.font = 'bold 14px Arial'
        ctx.fillText(code, x + barWidth / 2, top + chartHeight + 25)

        ctx.font = '12px Arial'
        ctx.fillStyle = '#6B7280'

        const words = String(reason).split(' ')
        let line = ''
        let lineIndex = 0
        words.forEach(word => {
          const test = line ? line + ' ' + word : word
          if (ctx.measureText(test).width > slot - 8 && line) {
            ctx.fillText(line, x + barWidth / 2, top + chartHeight + 45 + lineIndex * 16)
            line = word
            lineIndex++
          } else {
            line = test
          }
        })
        if (line) {
          ctx.fillText(line, x + barWidth / 2, top + chartHeight + 45 + lineIndex * 16)
        }
      })

      return canvas.toDataURL('image/png')
    },

    buildRTransactionsFollowUpChartImage () {
      const canvas = document.createElement('canvas')
      canvas.width = 1000
      canvas.height = 470
      const ctx = canvas.getContext('2d')

      ctx.fillStyle = '#FFFFFF'
      ctx.fillRect(0, 0, canvas.width, canvas.height)

      const buckets = {}
      ;(this.filteredUnpaidReject || []).forEach(row => {
        const label = row.followUp || '-'
        buckets[label] = (buckets[label] || 0) + 1
      })

      const entries = Object.keys(buckets).map((label, index) => ({
        label,
        value: buckets[label],
        color: ['#5CABAE', '#EF4444', '#F59E0B', '#6366F1', '#8B5CF6', '#10B981'][index % 6]
      }))

      const total = entries.reduce((sum, item) => sum + item.value, 0)
      const cx = 300
      const cy = 230
      const radius = 150
      const innerRadius = 82
      let startAngle = -Math.PI / 2

      if (total > 0) {
        entries.forEach(item => {
          const angle = (item.value / total) * Math.PI * 2

          ctx.beginPath()
          ctx.arc(cx, cy, radius, startAngle, startAngle + angle)
          ctx.arc(cx, cy, innerRadius, startAngle + angle, startAngle, true)
          ctx.closePath()
          ctx.fillStyle = item.color
          ctx.fill()

          startAngle += angle
        })
      } else {
        ctx.strokeStyle = '#E5E7EB'
        ctx.lineWidth = radius - innerRadius
        ctx.beginPath()
        ctx.arc(cx, cy, (radius + innerRadius) / 2, 0, Math.PI * 2)
        ctx.stroke()
      }

      ctx.textAlign = 'center'
      ctx.fillStyle = '#374151'
      ctx.font = 'bold 38px Arial'
      ctx.fillText(String(total), cx, cy)

      ctx.font = '16px Arial'
      ctx.fillStyle = '#6B7280'
      ctx.fillText('R-Transactions', cx, cy + 30)

      ctx.textAlign = 'left'
      entries.forEach((item, index) => {
        const y = 100 + index * 48
        ctx.fillStyle = item.color
        ctx.fillRect(590, y - 15, 22, 22)

        ctx.fillStyle = '#374151'
        ctx.font = '16px Arial'
        const pct = total ? ((item.value / total) * 100).toFixed(1) : '0.0'
        ctx.fillText(`${item.label}: ${item.value} (${pct}%)`, 630, y + 2)
      })

      return canvas.toDataURL('image/png')
    },

    exportRTransactionsPdf () {
      try {
        const rows = this.filteredUnpaidReject || []
        const info = this.crtInfo || {}
        const doc = new jsPDF({
          orientation: 'landscape',
          unit: 'mm',
          format: 'a4'
        })

        const pageWidth = doc.internal.pageSize.getWidth()
        const pageHeight = doc.internal.pageSize.getHeight()
        const teal = [92, 171, 174]
        const dark = [40, 55, 70]
        const muted = [105, 105, 105]

        // =====================================================
        // PAGE 1 - PAGE DE GARDE
        // Même structure que les exports Mandate / Collection.
        // =====================================================
        doc.setFont('helvetica', 'normal')
        doc.setFontSize(11)
        doc.setTextColor(...muted)
        doc.text('R-TRANSACTIONS REPORTING', pageWidth / 2, 30, { align: 'center' })

        doc.setFont('helvetica', 'bold')
        doc.setFontSize(30)
        doc.setTextColor(...dark)
        doc.text('R-Transactions Dashboard', pageWidth / 2, 52, { align: 'center' })

        doc.setDrawColor(...teal)
        doc.setLineWidth(1)
        doc.line(pageWidth / 2 - 35, 61, pageWidth / 2 + 35, 61)

        doc.setFont('helvetica', 'bold')
        doc.setFontSize(22)
        doc.setTextColor(50, 50, 50)
        doc.text(info.cdtr_name || '-', pageWidth / 2, 84, { align: 'center' })

        doc.setFont('helvetica', 'normal')
        doc.setFontSize(11)
        doc.setTextColor(100, 100, 100)
        const address = [info.cdtr_address, info.cdtr_city, info.cdtr_country]
          .filter(Boolean)
          .join(', ')
        doc.text(address || '-', pageWidth / 2, 94, { align: 'center' })

        const boxWidth = 105
        const boxHeight = 42
        const boxX = (pageWidth - boxWidth) / 2
        const boxY = 112

        doc.setFillColor(247, 249, 250)
        doc.setDrawColor(225, 230, 235)
        doc.roundedRect(boxX, boxY, boxWidth, boxHeight, 3, 3, 'FD')

        doc.setFont('helvetica', 'bold')
        doc.setFontSize(10)
        doc.setTextColor(100, 100, 100)
        doc.text('REPORT GENERATED BY', pageWidth / 2, boxY + 10, { align: 'center' })

        doc.setFontSize(14)
        doc.setTextColor(50, 50, 50)
        doc.text(info.user_name || '-', pageWidth / 2, boxY + 22, { align: 'center' })

        doc.setFont('helvetica', 'normal')
        doc.setFontSize(10)
        doc.setTextColor(100, 100, 100)
        doc.text(info.user_login || '-', pageWidth / 2, boxY + 31, { align: 'center' })

        doc.setFontSize(9)
        doc.setTextColor(130, 130, 130)
        doc.text(
          `Generated on ${moment().format('YYYY-MM-DD HH:mm:ss')}`,
          pageWidth / 2,
          pageHeight - 20,
          { align: 'center' }
        )

        // =====================================================
        // PAGE 2 - REJECTS & R-TRANSACTIONS BY MOTIF
        // KPI + graphique identiques à l'IHM.
        // =====================================================
        doc.addPage()
        doc.setFont('helvetica', 'bold')
        doc.setFontSize(19)
        doc.setTextColor(...dark)
        doc.text(
          this.$t('mandate.dashboard.rejects_rtransactions_by_motif'),
          pageWidth / 2,
          16,
          { align: 'center' }
        )

        const drawKpi = (x, y, width, label, value) => {
          doc.setFillColor(248, 249, 250)
          doc.setDrawColor(225, 230, 235)
          doc.roundedRect(x, y, width, 25, 2, 2, 'FD')
          doc.setFont('helvetica', 'normal')
          doc.setFontSize(8)
          doc.setTextColor(...muted)
          doc.text(String(label), x + width / 2, y + 8, { align: 'center', maxWidth: width - 8 })
          doc.setFont('helvetica', 'bold')
          doc.setFontSize(13)
          doc.setTextColor(...dark)
          doc.text(String(value), x + width / 2, y + 18, { align: 'center', maxWidth: width - 8 })
        }

        drawKpi(
          36, 26, 100,
          this.$t('mandate.dashboard.total_rejects_period'),
          this.rejectKpis.total.toLocaleString('en-US')
        )
        drawKpi(
          161, 26, 100,
          this.$t('mandate.dashboard.top_return_code'),
          this.rejectKpis.topMotif
        )

        const motifChartImage = this.buildRTransactionsMotifChartImage()
        doc.addImage(motifChartImage, 'PNG', 20, 58, 257, 112)

        // Résumé des codes sous le graphique : même information que l'IHM,
        // lisible également lorsque certaines barres sont à 0.
        const motifSummaryRows = Object.keys(this.motifBuckets).map(code => {
          const option = this.motifOptions.find(item => item.code === code)
          const row = this.filteredRejectStats.find(item => item.motif === code)
          return [
            code,
            (row && row.motifLabel) || (option && option.label) || '-',
            this.motifBuckets[code]
          ]
        })

        autoTable(doc, {
          startY: 174,
          head: [['Return code', 'Return reason', 'Count']],
          body: motifSummaryRows,
          theme: 'grid',
          styles: { fontSize: 7, cellPadding: 1.3 },
          headStyles: {
            fillColor: teal,
            textColor: 255,
            fontStyle: 'bold'
          },
          columnStyles: {
            0: { cellWidth: 35 },
            1: { cellWidth: 170 },
            2: { cellWidth: 35, halign: 'right' }
          },
          margin: { left: 28, right: 28 }
        })

        // =====================================================
        // PAGE 3 - KPI + FOLLOW-UP STATUS
        // =====================================================
        doc.addPage()
        doc.setFont('helvetica', 'bold')
        doc.setFontSize(19)
        doc.setTextColor(...dark)
        doc.text(
          this.$t('mandate.dashboard.unpaid_reject_statistics'),
          pageWidth / 2,
          16,
          { align: 'center' }
        )

        const gap = 5
        const cardWidth = (pageWidth - 20 - gap * 3) / 4
        const labels = [
          this.$t('mandate.dashboard.total_rejects_unpaid'),
          this.$t('mandate.dashboard.total_amount'),
          this.$t('mandate.dashboard.reject_rate'),
          this.$t('mandate.dashboard.fraud_rate')
        ]
        const values = [
          this.unpaidRejectKpis.totalCount,
          this.unpaidRejectKpis.totalAmountLabel,
          `${this.unpaidRejectKpis.rejectRate} %`,
          `${this.unpaidRejectKpis.fraudRate} %`
        ]

        labels.forEach((label, index) => {
          drawKpi(10 + index * (cardWidth + gap), 27, cardWidth, label, values[index])
        })

        doc.setFont('helvetica', 'bold')
        doc.setFontSize(12)
        doc.setTextColor(...dark)
        doc.text(this.$t('mandate.dashboard.by_follow_up_status'), 10, 67)

        const followUpChartImage = this.buildRTransactionsFollowUpChartImage()
        doc.addImage(followUpChartImage, 'PNG', 48, 73, 200, 94)

        // =====================================================
        // PAGE 4+ - R-TRANSACTIONS DETAIL
        // Lisible métier : type R, code ISO, raison, débiteur, etc.
        // =====================================================
        doc.addPage()
        doc.setFont('helvetica', 'bold')
        doc.setFontSize(18)
        doc.setTextColor(...dark)
        doc.text('R-Transactions Detail', pageWidth / 2, 15, { align: 'center' })

        doc.setFont('helvetica', 'normal')
        doc.setFontSize(9)
        doc.setTextColor(...muted)
        doc.text(`${rows.length} R-transaction(s)`, pageWidth / 2, 22, { align: 'center' })

        const tableRows = rows.map(row => {
          const raw = row.raw || {}
          return [
            row.date || '',
            row.rTransactionType || row.incidentType || '',
            row.motif || '',
            row.motifLabel || row.nature || '',
            row.followUp || '',
            row.isRecurring
              ? this.$t('mandate.transaction_type_recurring')
              : this.$t('mandate.transaction_type_one_off'),
            this.reportingValue(raw, 'dbtr_name', 'DbtrName') || '',
            this.reportingValue(raw, 'dbtr_IBAN', 'DbtrIBAN', 'dbtr_iban') || '',
            `${Number(row.amount || 0).toFixed(2)} EUR`,
            this.reportingValue(raw, 'UMR', 'umr') || ''
          ]
        })

        autoTable(doc, {
          startY: 29,
          head: [[
            'Date',
            'R-Transaction',
            'Return code',
            'Return reason',
            'Status',
            'Transaction type',
            'Debtor',
            'Debtor IBAN',
            'Amount',
            'UMR'
          ]],
          body: tableRows,
          theme: 'grid',
          styles: {
            fontSize: 6.5,
            cellPadding: 1.7,
            valign: 'middle',
            overflow: 'linebreak'
          },
          headStyles: {
            fillColor: teal,
            textColor: 255,
            fontStyle: 'bold',
            halign: 'center'
          },
          columnStyles: {
            0: { cellWidth: 19 },
            1: { cellWidth: 22 },
            2: { cellWidth: 18 },
            3: { cellWidth: 38 },
            4: { cellWidth: 24 },
            5: { cellWidth: 25 },
            6: { cellWidth: 29 },
            7: { cellWidth: 45 },
            8: { cellWidth: 22, halign: 'right' },
            9: { cellWidth: 45 }
          },
          margin: { left: 5, right: 5 }
        })

        // Footer on every content page.
        const pageCount = doc.getNumberOfPages()
        for (let page = 2; page <= pageCount; page++) {
          doc.setPage(page)
          doc.setFont('helvetica', 'normal')
          doc.setFontSize(8)
          doc.setTextColor(130, 130, 130)
          doc.text(info.cdtr_name || '', 10, pageHeight - 7)
          doc.text(`Page ${page} / ${pageCount}`, pageWidth - 10, pageHeight - 7, { align: 'right' })
        }

        const entityName = String(info.cdtr_name || 'r_transactions')
          .replace(/[^a-zA-Z0-9_-]/g, '_')

        doc.save(
          `${entityName}_r_transactions_dashboard_${moment().format('YYYYMMDD_HHmmss')}.pdf`
        )

        this.$f7.alert('', this.$i18n.t('common.exprt_succ'))
      } catch (e) {
        errorMessageAlert(this, e)
      }
    },

    applyFilters () {
      this.fetchStats()
    },
    formatDuration (milliseconds) {
      return `${Math.round(milliseconds).toLocaleString('en-US')} ms`
    },
    severityVariant (severity) {
      if (severity === 'Élevée') return 'danger'
      if (severity === 'Moyenne') return 'warning'
      return 'info'
    },
    errorStatusVariant (status) {
      if (status === 'Résolu' || status === 'Résolu automatiquement') return 'success'
      if (status === 'Action requise') return 'danger'
      if (status === 'Vérification métier') return 'warning'
      return 'info'
    },
    abandonmentVariant (rate) {
      if (rate >= 5) return 'danger'
      if (rate >= 2) return 'warning'
      return 'success'
    },
    statusVariant (status) {
      switch (status) {
        case 'Point de friction': return 'danger'
        case 'Bon': return 'info'
        case 'Opérationnel': return 'success'
        default: return 'secondary'
      }
    },
    reportingValue (row, ...keys) {
      for (const key of keys) {
        if (row && row[key] !== undefined && row[key] !== null) return row[key]
      }
      return null
    },
    reportingReasonLabel (code) {
      if (!code) return '-'
      const key = `mandate.sdd_reject_codes.${code}`
      const translated = this.$t(key)
      return translated === key ? code : translated
    },
    loadUnpaidRejectReporting () {
      this.activateSpinner = true

      const params = {
        type: 3,
        dateBegin: this.dateBeginFilter,
        dateEnd: this.dateEndFilter
      }

      return this.$engine.Reporting.getReporting(params)
        .then(resp => {
          const payload = (resp && resp.data) || {}
          const rows = Array.isArray(payload.Reporting)
            ? payload.Reporting
            : Array.isArray(payload.reporting)
              ? payload.reporting
              : Array.isArray(payload.Collection)
                ? payload.Collection
                : Array.isArray(payload)
                  ? payload
                  : []

          const rTransactionStatuses = ['6', '8', '9', '10']

          const normalized = rows
            .filter(row => {
              const status = String(this.reportingValue(row, 'status', 'Status') ?? '')
              return rTransactionStatuses.includes(status)
            })
            .map(row => {
              const status = String(this.reportingValue(row, 'status', 'Status') ?? '')
              const reasonCode = this.reportingValue(row, 'rejection_reason', 'RejectionReason') || '-'
              const rTransactionType = this.reportingValue(row, 'rejection_code', 'RejectionCode') || '-'
              const amount = Number(this.reportingValue(row, 'amount', 'Amount') || 0)
              const creationDate = this.reportingValue(row, 'creation_date', 'CreationDate', 'due_date', 'DueDate')
              const transactionType = String(this.reportingValue(row, 'type_transaction', 'TypeTransaction') ?? '')

              return {
                date: creationDate ? moment(creationDate).format('YYYY-MM-DD') : '-',
                nature: this.reportingReasonLabel(reasonCode),
                motif: reasonCode,
                motifLabel: this.reportingReasonLabel(reasonCode),
                count: 1,
                amount,
                isFraud: false,
                isRecurring: transactionType === '2' || transactionType.toUpperCase() === 'RCUR',
                followUp: this.collectionStatusLabel(status),
                emitter: this.reportingValue(row, 'cdtr_name', 'CdtrName') || '-',
                incidentType: rTransactionType,
                status,
                rTransactionType,
                raw: row
              }
            })

          this.unpaidRejectStats = normalized
          this.rejectStats = normalized.map(row => ({
            date: row.date,
            emitter: row.emitter,
            motif: row.motif,
            motifLabel: row.motifLabel,
            count: row.count,
            amount: row.amount
          }))
        })
        .catch(e => errorMessageAlert(e, this))
        .finally(() => { this.activateSpinner = false })
    },
    fetchStats () {
      if (this.mainTabIndex === 6) {
        return this.loadUnpaidRejectReporting()
      }
      if (this.mainTabIndex === 4) {

        if (!this.mandateStats.length) {
          this.$engine.Reporting.getReporting({ type: 1 })
            .then(resp => {
              const payload = (resp && resp.data) || {}
              this.mandateStats = Array.isArray(payload.Reporting)
                ? payload.Reporting
                : Array.isArray(payload.reporting)
                  ? payload.reporting
                  : Array.isArray(payload.Mandates)
                    ? payload.Mandates
                    : Array.isArray(payload)
                      ? payload
                      : []
            })
            .catch(e => errorMessageAlert(e, this))
        }
        this.activateSpinner = false
        return
      }
      if (this.mainTabIndex === 2 || this.mainTabIndex === 3) {

        this.activateSpinner = false
        return
      }
      this.activateSpinner = true
      const statusValue = this.statusFilter === 'All' ? '' : this.statusFilter

      if (this.mainTabIndex === 0) {
        // Statut des mandats
        const params = {
          type: 1,
          dateBegin: this.dateBeginFilter,
          dateEnd: this.dateEndFilter,
          status_mandate: statusValue
        }
        this.$engine.Reporting.getReporting(params)
        .then(resp => {
          const payload = (resp && resp.data) || {}

          this.mandateStats = Array.isArray(payload.Reporting)
            ? payload.Reporting
            : Array.isArray(payload.reporting)
              ? payload.reporting
              : Array.isArray(payload.Mandates)
                ? payload.Mandates
                : Array.isArray(payload)
                  ? payload
                  : []

          this.crtInfo = Object.keys(payload.crt_info || {}).reduce((acc, key) => {
            acc[key.trim()] = payload.crt_info[key]
            return acc
          }, {})
          })
          .catch(e => errorMessageAlert(e, this))
          .finally(() => { this.activateSpinner = false })
      } else {
        // Statut des collections
        const params = {
          type: 2,
          Status: statusValue,
          StartDueDate: this.dateBeginFilter,
          EndDueDate: this.dateEndFilter,
          firstIndex: 1
        }
        this.$engine.Reporting.getReporting(params)
          .then(resp => {
            const payload = (resp && resp.data) || {}
            this.collectionStats = Array.isArray(payload.Reporting)
            ? payload.Reporting
            : Array.isArray(payload.reporting)
              ? payload.reporting
              : Array.isArray(payload.Collection)
                ? payload.Collection
                : Array.isArray(payload)
                  ? payload
                  : []
          })
          .catch(e => errorMessageAlert(e, this))
          .finally(() => { this.activateSpinner = false })
      }
    },
    exportData () {
      const esc = v => `"${String(v ?? '').replace(/"/g, '""')}"`
      let headers
      let rows

      if (this.mainTabIndex === 4) {
        headers = ['Section', 'Detail']
        rows = [
          ['1. Mandate status', this.currentLabels.map((l, i) => `${l}: ${this.currentValues[i]}`).join(' | ')],
          ['2. Rejects by motif', Object.keys(this.motifBuckets).map(k => `${k}: ${this.motifBuckets[k]}`).join(' | ')],
          ['3. Representation success rate', this.representationTableItems.map(r => `${r.reason}: ${r.successRate}`).join(' | ')],
          ['4. Recovery rate', `${this.recoveryKpis.rate}% - avg delay ${this.recoveryKpis.avgDelayDays}d - unpaid ${this.recoveryKpis.unpaidAmountLabel}`],
          ['5. Usage / audit', this.auditStats.map(a => `${a.action}: ${a.count}`).join(' | ')],
          ['6. Fraud alerts', this.fraudStats.map(f => `${f.date} ${f.type} (${f.severity})`).join(' | ')]
        ]
      } else if (this.mainTabIndex === 3) {
        headers = ['Page', 'Vues', 'Utilisateurs uniques', 'Temps moyen de traitement (ms)', 'Taux d’abandon (%)', 'Taux de réussite (%)', 'Erreurs', 'Statut', 'Étape suivante']
        rows = this.userJourneyStats.map(row => [
          row.page, row.views, row.uniqueUsers, row.avgTimeMs, row.abandonmentRate, row.successRate, row.errors, row.status, row.nextStep
        ])
      } else if (this.mainTabIndex === 2) {
        headers = ['Type d’erreur', 'Tentatives échouées', 'Sévérité', 'Canal de souscription', 'Profil utilisateur', 'Échec stage', 'Average resolution time (min)', 'Statut', 'Dernière occurrence']
        rows = this.signatureErrorStats.map(row => [
          row.errorType,
          row.count,
          row.severity,
          row.channel,
          row.userProfile,
          row.ÉchecStage,
          row.avgResolutionMin,
          row.status,
          row.lastOccurrence
        ])
      } else if (this.mainTabIndex === 0 || this.mainTabIndex === 1) {
        headers = ['Entité SNCF', 'Count', 'Montant (EUR)']
        rows = this.filteredEntityStats.map(row => [row.entity, row.count, row.amount])
      } else {
        headers = ['Statut', 'Count']
        rows = this.currentLabels.map((label, idx) => [label, this.currentValues[idx]])
      }

      const csv = [headers, ...rows].map(r => r.map(esc).join(';')).join('\r\n')

      const linkSource = 'data:text/csv;charset=utf-8;base64,' + btoa(csv)
      const fileName = 'dashboard_export_' + moment().unix() + '.csv'

      const a = document.createElement('a')
      a.href = linkSource
      a.download = fileName
      a.click()
    }
  }
}
</script>

<style scoped>
.responsive-button {
  font-size: 0.9rem;
}

.responsive-button-small {
  font-size: 0.8rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.overview-intro {
  color: #6b7280;
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
}

.overview-section-title {
  color: var(--actionButtonColorBlue);
  font-weight: 600;
  margin-bottom: 1rem;
}

.kpi-card-compact {
  min-height: 52px;
  padding: 0.6rem 1rem;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  background: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.legend-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.legend-item-dashboard {
  display: flex;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid rgba(0,0,0,0.05);
}

.legend-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin-right: 0.75rem;
  flex-shrink: 0;
}

.legend-label {
  flex-grow: 1;
  color: var(--actionTextColorBlack);
}

.legend-value {
  font-weight: bold;
  color: var(--actionButtonColorBlue);
}

.journey-description {
  border-left: 4px solid var(--actionButtonColorBlue);
}

.kpi-card {
  min-height: 118px;
  padding: 1rem;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.kpi-card-warning {
  border-left: 4px solid #f59e0b;
}

.kpi-label {
  font-size: 0.85rem;
  color: #6b7280;
  margin-bottom: 0.45rem;
}

.kpi-value {
  font-size: 1.7rem;
  color: var(--actionButtonColorBlue);
}

.kpi-value-small {
  font-size: 1.05rem;
}

.journey-chart {
  height: 460px;
  position: relative;
}

.volume-chart {
  height: 380px;
  position: relative;
  margin-bottom: 2rem;
}

.clickable-rows ::v-deep tbody tr {
  cursor: pointer;
}

::v-deep .table-responsive table thead th {
  text-align: center;
  vertical-align: middle;
}

::v-deep .table-responsive table tbody td {
  text-align: center;
  vertical-align: middle;
}

@media (max-width: 767px) {
  .journey-chart {
    height: 580px;
  }
  .volume-chart {
    height: 380px;
  }
}


.journey-description {
  border-left: 4px solid var(--actionButtonColorBlue);
}

.error-chart {
  height: 430px;
}

.error-summary-panel {
  height: 100%;
  min-height: 300px;
  padding: 1.25rem;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.summary-line {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.85rem 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.summary-line:last-child {
  border-bottom: 0;
}

.summary-line span {
  color: #6b7280;
}

.summary-line strong {
  color: var(--actionButtonColorBlue);
  text-align: right;
}
.export-wrapper {
  position: relative;
  display: inline-block;
}

.export-menu {
  position: absolute;
  right: 0;
  bottom: 100%;
  margin-bottom: 6px;
  min-width: 150px;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  overflow: hidden;
}

.export-menu-item {
  display: block;
  width: 100%;
  padding: 10px 15px;
  border: none;
  background: white;
  text-align: left;
  cursor: pointer;
}

.export-menu-item:hover {
  background: #f5f5f5;
}

.export-menu-item + .export-menu-item {
  border-top: 1px solid #eeeeee;
}
.collection-kpi-card {
  height: 100%;
  min-height: 105px;
  padding: 18px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  text-align: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

.collection-kpi-label {
  margin-bottom: 8px;
  font-size: 13px;
  color: #6b7280;
}

.collection-kpi-value {
  font-size: 22px;
  font-weight: 600;
  color: #1f2937;
}

</style>
